module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "chp01"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chapternum",
    attrs: {
      "id": "p_1"
    }
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('h2', {
    staticClass: "chaptertitle1",
    attrs: {
      "id": "p_2"
    }
  }, [_vm._v("The Dignity of the Human Person, Human Rights, and Natural Law")]), _vm._v(" "), _c('p', {
    staticClass: "subhead2",
    attrs: {
      "id": "p_3"
    }
  }, [_vm._v("The Dignity of the Human Person")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_4"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_5"
    }
  }, [_vm._v("The practice of courtesy revels that people have an innate sense of the dignity of the human person. Even toward perfect strangers, many people will behave with good manners. We all know that the practice of courtesy makes civil life much more enjoyable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_6"
    }
  }, [_vm._v("C. S. Lewis provides us with an apt introduction to our reflection on the theme of human dignity in the comparison he makes between individuals and civilizations, noting that the former have an eternal destiny of happiness or misery, while the latter will one day perish.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_8"
    }
  }, [_vm._v("There are no "), _c('i', [_vm._v("ordinary")]), _vm._v(" people. You have never talked to a mere mortal. Nations, cultures, arts, civilizations—these are mortal, and their life is to ours as the life of a gnat. But it is immortals whom we joke with, work with, marry, snub, and exploit—immortal horrors or everlasting splendors."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn1_ch01",
      "id": "ch01_fn1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_9"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_10"
    }
  }, [_vm._v("Lewis also reminds us that by our actions we are “helping each other to one or other of these destinations.” I would also note that the character of the civilizations and cultures in which we live helps or hinders us in achieving a blessed eternal life. That is why Catholic social doctrine (CSD) on the dignity of the human person, human rights, and natural law is so important. Human dignity, properly understood, requires the kind of culture and political community in which it can thrive—in other words, the right kind of mores and laws. In fact, as Cardinal Höffner writes, “The ultimate purpose of all sociality is the perfection of personhood.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn2_ch01",
      "id": "ch01_fn2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("\nThat is to say, the reason that people live together in community is to achieve the perfection of human dignity, the integral development of the human person. As Pius XI says, “In the plan of the Creator, society is a natural means which man can and must use to reach his destined end. Society is for man and not vice versa.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn3_ch01",
      "id": "ch01_fn3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_11"
    }
  }, [_vm._v("The contemporary culture of liberalism, unfortunately, disposes citizens to have an incomplete understanding of human dignity. It inclines or tempts Americans, including Catholic Americans, to exercise their rights without taking into account what Catholicism teaches about the proper use of freedom or the right attitude toward the possession and use of material things. Persons are said to have dignity because they are autonomous and are capable of making choices. According to the most common opinion in contemporary society, the dignity of the human person is especially secured by ensuring the protection of rights. The initial and primary emphasis on rights is, of course, a logical step, since the autonomous exercise of choice requires the possession of rights. Catholic social doctrine certainly agrees that the dignity of the human person needs the protection of rights, but stresses that Catholics should exercise their rights in the light of faith and natural law, or they will diminish their dignity. This kind of emphasis is nearly absent in a liberal democracy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_12"
    }
  }, [_vm._v("Another consequence of understanding dignity as constituted by human autonomy is linking the assessment of human dignity to a person's quality of life, especially the capacity to make autonomous choices. It is now commonly thought that a person's dignity diminishes with his declining quality of life. Physical and mental deterioration, as well as suffering, supposedly diminish human dignity. In "), _c('i', [_vm._v("Quill v. Vacco")]), _vm._v(" (1997) the Second Circuit Court of Appeals even went so far as to make an ominous statement about legal obligations toward the terminally ill: “The state's interest lessens as the potential for life diminishes.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn4_ch01",
      "id": "ch01_fn4"
    }
  }, [_vm._v("4")])]), _vm._v(" The presence of this statement in a decision of an appeals court surely indicates a trend toward\n"), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("\nregarding those persons with diminished physical capacity as less than fully human. Some argue that they are not entitled to the same rights as healthy individuals. The Terri Schiavo case showed that the courts and many people gave their approval to the withdrawing of food and water from a person because of her poor quality of life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_13"
    }
  }, [_vm._v("Pope John Paul II makes reference to the contemporary assault on the traditional understanding of human dignity in his "), _c('i', [_vm._v("Evangelium vitae (Gospel of Life)")]), _vm._v(". He writes,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_14"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_15"
    }
  }, [_vm._v("We must also mention the mentality which tends to "), _c('i', [_vm._v("equate personal dignity with the capacity for verbal and explicit")]), _vm._v(", or at least perceptible "), _c('i', [_vm._v("communication")]), _vm._v(". It is clear that on the basis of these presuppositions there is no place in the world for anyone who, like the unborn or the dying, is a weak element in the social structure, or for anyone who appears completely at the mercy of others and radically dependent on them, and can only communicate through the silent language of a profound sharing of affection."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn5_ch01",
      "id": "ch01_fn5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_16"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_17"
    }
  }, [_vm._v("This way of understanding the human person is highly individualistic and fails to appreciate the rhythm of life, in which a person moves from the weakness and dependence of the unborn to the strength of adulthood, to the weakness of old age. Even during the time of people's strength, they are dependent in various ways for their physical, intellectual, and spiritual care. In the Catholic mind, human beings retain their dignity when they are receiving care and may even grow in dignity. Think of the person who accepts his dependence and suffering as a way of identifying with the passion of Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_18"
    }
  }, [_vm._v("Discussion of human dignity naturally leads into discussion of human rights, because people readily understand that rights can afford some protection to the dignity of the human person. What is less clear to people is how to think about the exercise of rights in the light of some objective moral standard. The relation of natural law to human dignity is unclear these days, because few are conversant with natural law, and the subtle Catholic concept of human dignity has not been sufficiently explained in the United States. In order to advance the discussion in Catholic circles on these subjects, the first section of this chapter draws upon both Catholic and non-Catholic sources to bring out the essential aspects of the Catholic concept of the dignity of the human person. The next section reflects on human rights and natural law in the light of that Catholic concept\n"), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("\nof human dignity. This second section explains why Catholic social doctrine both defends and criticizes contemporary understandings of human rights and insists on the importance of natural law for public life in the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_19"
    }
  }, [_vm._v("The Nature and Basis of Human Dignity")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_20"
    }
  }, [_vm._v("Careful education is necessary for Catholics to understand that the dignity of the human person is not essentially constituted by the ability to make choices. According to Catholic teaching, people have dignity because they are created in the image and likeness of God, redeemed by Jesus Christ, and destined for eternal life in communion with God. In Pope John Paul II's words,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_21"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_22"
    }
  }, [_vm._v("The dignity of the person is manifested in all its radiance when the person's origin and destiny are considered: created by God in his image and likeness as well as redeemed by the most precious blood of Christ, the person is called to be a “child in the Son” and a living temple of the Spirit, destined for eternal life of blessed communion with God."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn6_ch01",
      "id": "ch01_fn6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_23"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_24"
    }
  }, [_vm._v("The threefold foundation for human dignity is both unshakable and instructive. No act of the human person can remove this foundation. Even when people commit the worst sins and crimes and suffer diminished physical and spiritual capacities, they retain human dignity. While this Christian teaching about the permanent character of human dignity is often mentioned and acknowledged by informed Christians, rarely do Catholics hear that human dignity is also a goal or an achievement. But this is the clear implication of the threefold foundation of human dignity and the explicit teaching of Vatican Council II and John Paul II.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_25"
    }
  }, [_vm._v("As Vatican Council II puts it, “The principal cause of human dignity lies in the call of human beings to communion with God.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn7_ch01",
      "id": "ch01_fn7"
    }
  }, [_vm._v("7")])]), _vm._v(" Being created in the image of God and redeemed by Jesus Christ makes it possible for everyone to respond to God's invitation to communion with him. Because it is the actual communion with God that perfects the dignity of human beings, Vatican II says, that the “dignity of man…is rooted and perfected\n"), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("\nin God” ("), _c('i', [_vm._v("in ipso Deo fundetur et perficiatur")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn8_ch01",
      "id": "ch01_fn8"
    }
  }, [_vm._v("8")])]), _vm._v(" It is important to note that only through the mystery of the Incarnation and the redemption do human beings fully understand themselves, especially their call to communion with God. During his pontificate Pope John Paul II kept reminding us of this point by quoting a sentence from "), _c('i', [_vm._v("Gaudium et spes (Pastoral Constitution on the Church in the Modern World)")]), _vm._v(", no. 22: “Christ the new Adam, in the very mystery of the Father and his love, "), _c('i', [_vm._v("fully reveals man to himself")]), _vm._v(" and brings to light his most high calling.” In other words, Jesus Christ makes known to man his eminent dignity, a being destined for communion with his Creator, and the means to realize it every day: avoidance of sin and the practice of all the virtues, especially charity. Still otherwise stated, human beings are true to their dignity when they imitate the love of Jesus Christ, the love he showed for every single human being by dying on the cross.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_26"
    }
  }, [_vm._v("Given the foundation of human dignity and the reality of sin, it logically follows that all will have to strive and strain to reach their ultimate goal, communion with the triune God. All human beings are able to do this because God “willed to leave man ‘in the power of his own counsel’ (cf. Sir 15:14), so that he would seek his Creator of his own accord and would fully arrive at full and blessed perfection by cleaving to God.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn9_ch01",
      "id": "ch01_fn9"
    }
  }, [_vm._v("9")])]), _vm._v(" Given God's action, “human dignity requires that a person act according to a conscious and free choice,” in seeking what is good. The council describes the effect of such human action on human dignity in the language of achievement.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_27"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_28"
    }
  }, [_vm._v("Man realizes such dignity [that of “full and blessed perfection”] when emancipating himself from all captivity to passion, he pursues his goal in a spontaneous choice of what is good, and procures for himself through effective and skillful action, apt means to that end. Since man's freedom has been damaged by sin, only by the help of God's grace can he bring such a relationship with God to full flower."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn10_ch01",
      "id": "ch01_fn10"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_29"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_30"
    }
  }, [_vm._v("It is, of course, true to note that very few will succeed in freeing themselves from all captivity to passion. Nevertheless, everyone has the capacity, with the help of God's grace, of moving toward the dignity of perfection.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_31"
    }
  }, [_vm._v("The council makes the same point when discussing the obligation of all to obey their conscience. “Man has a law in his heart inscribed by God, to obey which is his very dignity, and according to which he will be judged.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn11_ch01",
      "id": "ch01_fn11"
    }
  }, [_vm._v("11")])]), _vm._v(" The text implies that people diminish their dignity by not obeying their conscience. Everyday speech captures this human possibility in the expression “to act beneath one's dignity.” In sum, all people continually "), _c('i', [_vm._v("achieve")]), _vm._v(" or realize their dignity by seeking the truth, obeying conscience, resisting sin, practicing virtue, and repenting when they succumb to temptation. In other words, dignity is not just a permanent possession, unaffected by the way they live. All people have to obey their informed conscience, both to avoid acting beneath their dignity and to develop it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_32"
    }
  }, [_vm._v("So, there is a sense in which dignity may be continually diminished by a life of sin or progressively appropriated over a lifetime by seeking perfection, as John Paul II said. In "), _c('i', [_vm._v("Rerum novarum")]), _vm._v(", Pope Leo XIII made the same point using language characteristic of Thomas Aquinas: “true dignity and excellence in men resides in moral living, that is, in virtue.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn12_ch01",
      "id": "ch01_fn12"
    }
  }, [_vm._v("12")])]), _vm._v(" Saint Leo the Great's famous Christmas sermon states this point in a memorable way: “Christian, recognize your dignity, and now that you share in God's own nature, do not return by sin to your former base condition.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn13_ch01",
      "id": "ch01_fn13"
    }
  }, [_vm._v("13")])]), _vm._v(" It is significant that this quotation stands as the first sentence in the section on morality in the new "), _c('i', [_vm._v("Catechism of the Catholic Church")]), _vm._v(". It immediately directs attention to the necessity of achieving human dignity by living without sin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_33"
    }
  }, [_vm._v("Pope John Paul II argues that “genuine freedom is an outstanding manifestation of the divine image in man.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn14_ch01",
      "id": "ch01_fn14"
    }
  }, [_vm._v("14")])]), _vm._v(" By genuine freedom the pope means freedom that takes its bearing by what is true and good, not the freedom that is indistinguishable from license. In other words, people who understand freedom as license will diminish their dignity by committing sin. On the other hand, people increase their dignity by living virtuously. Pope John Paul II goes so far as to say that martyrdom is “the supreme glorification of human dignity.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn15_ch01",
      "id": "ch01_fn15"
    }
  }, [_vm._v("15")])]), _vm._v(" This statement makes eminent sense, because martyrs achieve the summit of human dignity by laying down their lives for God and neighbor. This is the reason martyrs are held in such high regard by Christians.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_34"
    }
  }, [_vm._v("The Vatican "), _c('i', [_vm._v("Guidelines for the Study and Teaching of the Church's Social Doctrine in the Formation of Priests")]), _vm._v(" says that human advancement depends on “ennobling the human person in all the dimensions of the natural and supernatural order” and that “man's true dignity is found in a spirit liberated from evil and renewed by Christ's redeeming grace.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn16_ch01",
      "id": "ch01_fn16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_35"
    }
  }, [_vm._v("The recent "), _c('i', [_vm._v("Compendium of the Social Doctrine of the Church")]), _vm._v(" also implies that human dignity is not just a given, but also a goal of the individual and the Church. “By her preaching of the Gospel, the grace of the sacraments, and the experience of fraternal communion, the Church ‘heals and elevates the dignity of the human person,…consolidates society and endows the daily activity of all people with a deeper sense and meaning.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn17_ch01",
      "id": "ch01_fn17"
    }
  }, [_vm._v("17")])]), _vm._v(" If the human dignity of the individual person necessarily receives healing and elevation by the activity of the Church, then it is not simply a given, needing only the protection of rights. Human beings cooperate with their healing and ennobling by repenting of their sins, avoiding them in the future, and contributing to the common good by practicing virtue in every area of their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_36"
    }
  }, [_vm._v("In its section on the human person the "), _c('i', [_vm._v("Compendium")]), _vm._v(" makes much of the fact that sin and its effects offend the dignity of the human person. When people act beneath their dignity by sinning, the consequences are “alienation, that is the separation of man not only from God, but also from himself, from other men and from the world around him.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn18_ch01",
      "id": "ch01_fn18"
    }
  }, [_vm._v("18")])]), _vm._v(" This separation or alienation, caused by sin, is an assault on human dignity because it is an obstacle to communion with God and to communion among human beings through their union with him. The piling up of personal sins produces structures of sin in society or the kind of twisted culture that becomes “sources of other sins, conditioning human conduct.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn19_ch01",
      "id": "ch01_fn19"
    }
  }, [_vm._v("19")])]), _vm._v(" In other words, the personal sins of enough individuals produce the kind of culture that will lead others into temptation and sin. So, when individuals act beneath their dignity, they harm the life of society.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_37"
    }
  }, [_vm._v("Two Different Explanations of the Dignity of the Human Person")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_38"
    }
  }, [_vm._v("In "), _c('i', [_vm._v("Centesimus Annus (On the Hundredth Anniversary of Rerum novarum)")]), _vm._v(" Pope John Paul II provides a perfect commentary on the importance of human dignity. “The guiding theme of Pope Leo's Encyclical, ["), _c('i', [_vm._v("Rerum novarum")]), _vm._v("], and of all of the Church's social doctrine, is a "), _c('i', [_vm._v("correct view of the human person")]), _vm._v(" and of his unique importance, inasmuch as ‘man…is the only creature on earth which God willed for itself.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn20_ch01",
      "id": "ch01_fn20"
    }
  }, [_vm._v("20")])]), _vm._v(" On the basis of faith and reason the Church proclaims the dignity of the human person as the foundation of Catholic social doctrine. There is no real disagreement on this teaching. Nor is there any disagreement on the threefold foundation of human dignity: creation in the image of God, redemption by Jesus Christ, and the call to eternal life in communion with God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_39"
    }
  }, [_vm._v("But there is an apparent disagreement in the explanation of this key concept. Consider the following statements made by the U.S. Bishops in 1990 and 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_40"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_41"
    }
  }, [_vm._v("In a world warped by materialism and declining respect for human life, the Catholic Church proclaims that human life is sacred and that the dignity of the human person is the foundation of a moral vision for society [and]…the foundation of all the principles of our social teaching…. We believe that every person is precious, that people are more important than things, and that the measure of every institution is whether it threatens or enhances the life and dignity of the human person."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn21_ch01",
      "id": "ch01_fn21"
    }
  }, [_vm._v("21")])]), _vm._v("…. Each person possesses a basic dignity that comes from God, not from any human quality or accomplishment, not from race or gender, or age, or economic status."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn22_ch01",
      "id": "ch01_fn22"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_42"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_43"
    }
  }, [_vm._v("These explanations point out important tenets of CSD—especially the understanding of human dignity as a permanent endowment—but do not mention that human dignity is in any way a quality or accomplishment. The bishops rightly focus on the permanent character of human dignity in order to protect vulnerable human beings from being declared unworthy of respect or of the law's protection because of poor quality of\n"), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("\nlife. The unborn child is particularly vulnerable, because people can argue that he or she cannot make choices and therefore lacks dignity. The bishops undoubtedly choose not to draw attention to the full range of Catholic teaching on the subject for fear of endangering the weak and vulnerable in society. This is a reasonable decision, given the climate in which we live. Yet, it may be more reasonable to proclaim both the permanent character of human dignity as well as the obligation to ennoble one's dignity by a life of holiness, "), _c('i', [_vm._v("with the help of divine grace")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn23_ch01",
      "id": "ch01_fn23"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_44"
    }
  }, [_vm._v("Without teaching the twofold character of human dignity, the very keystone of CSD is not accurately described and therefore not quite up to the task of informing the elaboration of other important themes in the discipline. As John Paul II said in "), _c('i', [_vm._v("Centesimus annus")]), _vm._v(", “from the Christian vision of the human person there necessarily follows a correct picture of society.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn24_ch01",
      "id": "ch01_fn24"
    }
  }, [_vm._v("24")])]), _vm._v(" That picture is one in which all elements of society should find ways to help people perfect their dignity. "), _c('i', [_vm._v("Gaudium et spes")]), _vm._v(", in fact, says at the beginning of its conclusion that the "), _c('i', [_vm._v("whole conciliar program")]), _vm._v(" for all people is to help them “so that perceiving more clearly their integral vocation, they may conform the world more to the surpassing dignity of the human person.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn25_ch01",
      "id": "ch01_fn25"
    }
  }, [_vm._v("25")])]), _vm._v(" A world so conformed would not only reflect the eminent dignity of human beings, but also be an instrument in helping people to achieve that dignity. A world not so conformed leads people astray, making the achievement of dignity more difficult.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_45"
    }
  }, [_vm._v("Every element of society should promote respect for human dignity and its perfection. As Vatican Council II specifically says, “it devolves on humanity to establish a political, social, and economic order which will to an even better extent serve man and help individuals as well as groups to affirm and perfect the dignity proper to them” ("), _c('i', [_vm._v("ad dignitatem sibi propriam affirmandam et excolendam")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn26_ch01",
      "id": "ch01_fn26"
    }
  }, [_vm._v("26")])]), _vm._v(" This means that the family, mediating institutions, the law, and the Church all have a role to play in helping individuals perfect their dignity. For example, the education a mother and father give to their children in the family will help them recognize and\n"), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("\nachieve their dignity. Schools, a primary mediating institution, to a greater or lesser extent, form the character of students so that they might be inclined to act in accordance with their dignity. The law encourages people not to act beneath their dignity by driving while drunk or acting in a discriminatory manner toward racial minorities. In "), _c('i', [_vm._v("Centesimus annus")]), _vm._v(" Pope John Paul II says that the Church contributes to the enrichment of human dignity when she “proclaims God's salvation to man, when she offers and communicates the life of God through the sacraments, when she gives direction to human life through the commandments of love of God and neighbor.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn27_ch01",
      "id": "ch01_fn27"
    }
  }, [_vm._v("27")])]), _vm._v(" These examples show that a correct conception of the human person provides guidance to all educators and to legislators, and also enables all people to recognize that they must strive to perfect their dignity in order to be good persons and even good democratic citizens.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_46"
    }
  }, [_vm._v("Because of his vision of the human person, the pope said the following about the democratic way of life:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_47"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_48"
    }
  }, [_vm._v("Democracy cannot be sustained without a shared commitment to certain moral truths about the human person and the human community. The basic question before a democratic society is “How ought we live together?” In seeking an answer to this question, can society exclude moral reasoning?…Every generation of Americans needs to know that freedom consists not in doing what we like, but in having the right to do what we ought."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn28_ch01",
      "id": "ch01_fn28"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_49"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_50"
    }
  }, [_vm._v("Clearly, Pope John Paul II's reflections on democracy are inspired by his understanding of human dignity. People perfect their dignity by using their freedom to live as they ought, and by so doing they contribute to the smooth functioning of a healthy democracy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_51"
    }
  }, [_vm._v("CSD needs more clarity about its foundational principle, and therefore must return to the basic questions: “What is a person?” and “what is human dignity?” A good way to approach these subjects is to reflect on the primacy of receptivity in the achievement of human dignity and on the high calling of the human person.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_52"
    }
  }, [_vm._v("Receptivity and Exhortation")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_53"
    }
  }, [_vm._v("Many years ago Professor Joseph Ratzinger, now Pope Benedict XVI, alerted me to the theme of receptivity in his justly famous "), _c('i', [_vm._v("Introduction to Christianity")]), _vm._v(". He writes, “From the point of view of the Christian faith, man\n"), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("\ncomes in the profoundest sense to himself not through what he does but through what he receives (or accepts)…. And one cannot become "), _c('i', [_vm._v("wholly")]), _vm._v(" man in any other way than by being loved, by letting oneself be loved.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn29_ch01",
      "id": "ch01_fn29"
    }
  }, [_vm._v("29")])]), _vm._v(" Otherwise stated, Mary's fiat is the model for the person who wants to live as a Christian: “Let it be done to me according to your word.” Persons who desire to realize their dignity must be receptive to instruction, exhortation, and grace in the various communities in which they live. Especially important are the family, Church, and school. But voluntary associations and even the law also play a role in creating and developing receptivity in people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_54"
    }
  }, [_vm._v("In various places of his autobiography Msgr. George Kelly captures the laborious struggle of the nuns in Catholic schools to educate young people to act in accord with their God-given dignity. At the very beginning of his story he tells of a meeting that he had with twenty-five of his former altar boys after addressing the New York City Police Holy Name Society. The police commissioner surprised Msgr. Kelly by bringing him into a VIP room to meet the twenty-five men who had become cops, even lieutenants and captains. “As I approached them,” Kelly wrote, “the best I could muster up, as a response to their warm greeting, was: ‘And to think that Sister De Padua and I expected most of you to end up in jail.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn30_ch01",
      "id": "ch01_fn30"
    }
  }, [_vm._v("30")])]), _vm._v(" After finishing his book I understood Msgr. Kelly's humorous hyperbole as a way of capturing all the time and effort that once went into forming the character of the young in a typical New York Catholic parish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_55"
    }
  }, [_vm._v("Regarding human dignity as an arduous achievement in a community characterized by receptivity and exhortation is not exclusively a Catholic teaching. Consider “Wasps' Nest,” a short story written by Agatha Christie. It seems to be about the poisoning of a wasps' nest with potassium cyanide. It turns out that John Harrison discovers that he is terminally ill and devises a plan to poison himself in such circumstances that another man, Claude Langton, will surely be blamed for his death and hanged. The terminally ill man is suddenly overcome with a desire for revenge against Monsieur Langton, who has won the heart of his former fiancée, a woman he still loves. Hercule Poirot realizes what is happening and tries to make his old friend come to his senses and give up his desire to commit murder.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_56"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_57"
    }
  }, [_vm._v("[Poirot] advanced to his friend and laid a hand on his shoulder. So agitated was he that he almost shook the big man, and as he did so, he hissed into his ear: “Rouse yourself, my friend, rouse yourself. And look—look where I am pointing. There on the bank, close by that tree root. See you, the wasps returning home, placid at the end of the day? In a little hour, there will be destruction and they know it not. There is no one to tell them. They have not, it seems, a Hercule Poirot.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn31_ch01",
      "id": "ch01_fn31"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_58"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_59"
    }
  }, [_vm._v("John Harrison resists the instruction and exhortation. Poirot then finds a way to substitute washing soda for the poison and confronts his friend after the failed suicide. Harrison moans when he realizes that Poirot has thwarted his suicide and saved Langton from being hanged for murder. Harrison asks, “Why did you come? Why did you come?” Poirot replies, of course, that he wanted to prevent a murder, and then adds:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_60"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_61"
    }
  }, [_vm._v("“Listen, "), _c('i', [_vm._v("mon ami")]), _vm._v(", you are a dying man; you have lost the girl you loved, but there is one thing you are not: you are not a murderer. Tell me now: are you glad or sorry that I came?” There was a moment's pause and Harrison drew himself up. There was a "), _c('i', [_vm._v("new dignity")]), _vm._v(" in his face—the look of a man who had conquered his own baser self. He stretched out his hand across the table. “Thank goodness you came,” he cried. “Oh! Thank goodness you came.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn32_ch01",
      "id": "ch01_fn32"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_62"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_63"
    }
  }, [_vm._v("The story is both an example of the education and transformation of a person's disordered desire by the prudent behavior and exhortation of his friend and, of course, an account of the achievement of dignity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_64"
    }
  }, [_vm._v("The receptivity of persons to instruction and exhortation is a most important element in the realization of their dignity. The ultimate end of a Christian community is both to educate the faithful to the love of God and neighbor with their whole heart and soul and to be a living witness to that love. If Christians enhance their dignity by growing in love for their neighbors, then there should be no doubt that human dignity is both a given and an end, a high goal to be achieved by laborious efforts with the help of God's grace.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_65"
    }
  }, [_vm._v("Human Dignity as a High Calling")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_66"
    }
  }, [_vm._v("Christian dignity is a high calling toward which a person walks with the support of fellow Christians. The patristic theme of "), _c('i', [_vm._v("epektasis")]), _vm._v(" presents\n"), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("\nan accurate image of this reality. The patristic scholar Professor Ernest Fortin explains, “The life of the soul, as the Church Fathers saw it, is characterized by unceasing progress, indeed, not just an "), _c('i', [_vm._v("extasis")]), _vm._v(" or going out of oneself but an "), _c('i', [_vm._v("epektasis")]), _vm._v(" or perpetual going beyond oneself in the direction of an ever more perfect God-likeness.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn33_ch01",
      "id": "ch01_fn33"
    }
  }, [_vm._v("33")])]), _vm._v(" In Philippians 3:12–14 St. Paul spoke in the same way: “One thing I do, forgetting what lies behind and straining forward ("), _c('i', [_vm._v("epekteinomenos")]), _vm._v(") to what lies ahead I press on toward the goal for the prize of the upward call of God in Jesus Christ.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_67"
    }
  }, [_c('i', [_vm._v("Epektasis")]), _vm._v(", of course, not only requires an individual effort, but also depends decisively on continuous instruction and exhortation in a Christian community. In Galatians 4:19 St. Paul says, “My children, for whom I again suffer birth-pangs until Christ be formed in you.” The language of birth pangs is a moving image conveying all that we have to do in order to help our brothers and sisters rouse themselves to put on Christ. For example, in the latter moments of life—especially in times of weakness, suffering, and depression—family members, friends, and health-care personnel play a crucial role in exhorting and sustaining the dying person. By giving and receiving loving exhortation Christians sustain one another's dignity. Where there is a failure to give and receive, the dignity of human persons is diminished. Otherwise stated, physicians who don't dissuade their patients from thinking of suicide diminish their own dignity, as do family members who abandon relatives to fear and loneliness. The proper understanding of a person's dignity would help Catholics resist the rhetoric of the euthanasia movements and move them to appreciate Christian teachings on the redemptive value of suffering and solidarity with the dying person.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_68"
    }
  }, [_vm._v("Bioethics and the Dignity of the Human Person")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_69"
    }
  }, [_vm._v("The Christian teaching that dignity is both a given and a high calling (or an achievement) can be appreciated by non-Christians and even by nonbelievers. Leon Kass's thinking on human dignity, as expounded in his book "), _c('i', [_vm._v("Life, Liberty and the Defense of Dignity: The Challenge for Bioethics")]), _vm._v(", will illustrate this point and further deepen our insight into the Catholic concept of human dignity. It may seem odd to rely on a Jewish intellectual to clarify Catholic teaching, but Kass does offer helpful clarifications by his\n"), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("\ndiscussion of the limitations of Kant's thought on human dignity. Kass is one of the nation's leading bioethicists and often a wonderful example of right reason in action."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn34_ch01",
      "id": "ch01_fn34"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_70"
    }
  }, [_vm._v("The most common understanding of human dignity in the contemporary period, Kass rightly argues, is that inspired by Immanuel Kant. The German philosopher attempts to supply a foundation for universal human dignity by his doctrine of respect for persons. Kass explains Kant's approach: “Persons—all persons or rational beings—are deserving of respect not because of some realized excellence of achievement, but because of a universally shared participation in morality and the ability to live under the moral law.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn35_ch01",
      "id": "ch01_fn35"
    }
  }, [_vm._v("35")])]), _vm._v(" This is the view that persons have dignity because they can reason and make choices. While Kass applauds Kant's efforts and his influence on promoting the respect for persons in contemporary canons of ethics, he finally judges Kant's view of human dignity as “"), _c('i', [_vm._v("inhuman")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_71"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_72"
    }
  }, [_vm._v("Precisely because it dualistically sets up the concept of “personhood” "), _c('i', [_vm._v("in opposition")]), _vm._v(" to nature and body, it fails to do justice to the concrete reality of our embodied lives—lives of begetting and belonging no less than willing and thinking…. Precisely, because “personhood” is distinct from our lives as embodied, rooted, connected, and aspiring beings, the dignity of rational choice pays no respect at all to the dignity we have through our loves and longings—central aspects of human life understood as grown togetherness of body and soul. Not all human dignity consists in reason or freedom."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn36_ch01",
      "id": "ch01_fn36"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_73"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_74"
    }
  }, [_vm._v("Under the influence of Kant even many Catholics look at human dignity simply as a given and not also as an end to be achieved by avoiding serious sin, loving one's family, friends, and neighbors, and seeking to realize communion with God. Catholics rightly look to God's creation of man in his image and likeness as the foundation of dignity, but then fail to see that living in accord with God's image is the way of realizing their dignity in their everyday life. It should be obvious that our longings and loves either increase or diminish our dignity, but this is not always the case.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_75"
    }
  }, [_vm._v("Kass makes his most extensive comments on dignity in his chapter on “Death with Dignity and the Sanctity of Life.” The roots of the English and Latin words for dignity are indicative. “The central notion etymologically, both in English and in its Latin root ("), _c('i', [_vm._v("dignitas")]), _vm._v("), is that of worthiness, elevation, honor, nobility, height—in short excellence or virtue.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn37_ch01",
      "id": "ch01_fn37"
    }
  }, [_vm._v("37")])]), _vm._v(" If dignity is understood as various kinds of excellence, then it cannot be provided or claimed as a right. It makes as little sense to assert a right to dignity as to claim a right to wisdom or courage. Realizing that this description may strike his readers as a denial of man's special dignity, Kass reaffirms his position that human beings have dignity because they are created in God's image and likeness, and that the sanctity of life is based on human dignity. “Yet,” he adds, “on further examination this universal attribution of dignity to human beings pays more tribute to human potentiality, to the "), _c('i', [_vm._v("possibilities")]), _vm._v(" for human excellence. "), _c('i', [_vm._v("Full")]), _vm._v(" dignity, or dignity properly so-called, would depend on the "), _c('i', [_vm._v("realization")]), _vm._v(" of these possibilities.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn38_ch01",
      "id": "ch01_fn38"
    }
  }, [_vm._v("38")])]), _vm._v(" So, the dignity of human beings is realized when they live a moral life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_76"
    }
  }, [_vm._v("Kass is right to say that full dignity depends on virtuous achievements. Why else would people say in ordinary speech, “That attitude or behavior is beneath your dignity?” I remain puzzled, however, why Kass doesn't make more of the permanent character of human dignity, even in those who choose to live badly. In a footnote he does say that “it may be salutary to treat people on the basis of their capacities to live humanly, despite great falling short or willful self-degradation.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn39_ch01",
      "id": "ch01_fn39"
    }
  }, [_vm._v("39")])]), _vm._v(" Still, he doesn't seem to go far enough. Because people are created in God's image, it "), _c('i', [_vm._v("is")]), _vm._v(" right and salutary to treat them on the basis of their inherent dignity and their capacities to live humanly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_77"
    }
  }, [_vm._v("Kass further argues that “the "), _c('i', [_vm._v("sanctity")]), _vm._v(" of human life rests absolutely on the "), _c('i', [_vm._v("dignity")]), _vm._v("—the god-likeness—of human beings.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn40_ch01",
      "id": "ch01_fn40"
    }
  }, [_vm._v("40")])]), _vm._v(" Kass arrives at this conclusion after examining the Ten Commandments, the story of Cain and Abel, and especially the covenant with Noah subsequent to the flood. Kass believes that murder is not wrong simply because God says so. Echoing Thomas's natural-law teaching, Kass says, “The entire second table of the Decalogue is said to propound not so much divine law as natural law, law suitable for man as man, not only for Jew or Christian.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn41_ch01",
      "id": "ch01_fn41"
    }
  }, [_vm._v("41")])]), _vm._v(" Cain's remark “Am I my brother's keeper?” shows that he senses the wrongness of\n"), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _vm._v("\nmurder. Otherwise, he could have responded to God's question regarding the whereabouts of Abel with the straightforward answer, “I killed him.” Kass explains, “If there was nothing wrong with murder, why hide one's responsibility? A ‘proto-religious’ dread accompanies the encounter with death, especially violent death.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn42_ch01",
      "id": "ch01_fn42"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_78"
    }
  }, [_vm._v("Kass finds the best evidence for his position in the story about the new order of things after the flood. God issues a prohibition enjoining all mankind to refrain from murder and explains why. Genesis 9:6 reads, “Whoever sheds the blood of man, by man shall his blood be shed; for God made man in his own image.” Kass comments, “The fundamental reason that makes murder wrong—and that even justifies punishing it homicidally!—is man's divine-like status. Not the other fellow's unwillingness to be killed, not even (or only) our desire to avoid sharing his fate, but "), _c('i', [_vm._v("his")]), _vm._v("—any man's—"), _c('i', [_vm._v("very being")]), _vm._v(" requires that we respect his life.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn43_ch01",
      "id": "ch01_fn43"
    }
  }, [_vm._v("43")])]), _vm._v(" Kass goes to Genesis I to elucidate the meaning of God-like. It means that man speaks, reasons, contemplates, exercises freedom, makes judgments, distinguishes good from bad, and “lives a life freighted with moral self-consciousness.” All these qualities give human beings a dignity that engenders and requires respect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_79"
    }
  }, [_vm._v("Kass believes the achievement of dignity is possible when people have the proper models to imitate and the right kind of education. He shows that this achievement is frequently noticed in the ordinary routine of life. “In truth, if we know how to look, we find evidence of human dignity all around us, in the valiant efforts ordinary people make to meet necessity, to combat adversity and disappointment, to provide for their children, to care for their parents, to help their neighbors, to serve their country.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn44_ch01",
      "id": "ch01_fn44"
    }
  }, [_vm._v("44")])]), _vm._v(" Of course, people need various virtues to make these kinds of valiant efforts, which is still another indication that we have to strive day in, day out to realize our dignity. The achievement of dignity is really the most ordinary occurrence, but not a common phrase in everyday speech. The absence of appropriate language keeps us from accurately perceiving all aspects of dignity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_80"
    }
  }, [_vm._v("What does get talked about is death with dignity. By that term people mean both good and bad things. The good side is the belief that people should not be dehumanized at the end of life by unnecessary or burdensome medical treatments, or subject to unnecessary institutionalization.\n"), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("\nThe chilling side of death with dignity is the argument that euthanasia or physician-assisted suicide will assure the dignity of a terminally ill patient whose quality of life has diminished. Kass calls euthanasia “undignified and dangerous.” The assault on human dignity, he argues, comes not from the declining quality of life, but from improper treatment and care by hospital staff, relatives, and friends. “Withdrawal of contact, affection and care is probably the greatest single cause of the dehumanization of dying. Death with dignity requires absolutely that the survivors treat the human being at all times as if full god-likeness remains, up to the very end.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn45_ch01",
      "id": "ch01_fn45"
    }
  }, [_vm._v("45")])]), _vm._v(" Encouragement by “many small speeches and deeds” will shore up the courage of the dying and help them to face their physical and emotional pain."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn46_ch01",
      "id": "ch01_fn46"
    }
  }, [_vm._v("46")])]), _vm._v(" By bearing up in the face of suffering, the dying person, argues Kass, maintains and increases his dignity, as do his loving relatives and friends. There is no dignity in asking for lethal injections from relatives and friends. Placing such a burden on people is not dignified action.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_81"
    }
  }, [_vm._v("Kass's reflection on Kant, bioethics, and the everyday events of daily life has confirmed Catholic teaching on dignity as a permanent endowment and an achievement. What remains to be done is to flesh out and make intelligible the full meaning of human dignity through conversations in both private and public places. Otherwise, dignity will not be able to provide a secure foundation for human rights. Rights will be respected when people both realize that it is beneath their dignity to violate them and acquire the virtues that will enable them to live a dignified life. Of course, this means that rights will frequently not be respected, since people will not always make the effort to live a dignified life. Catholics could make even more of a contribution to the well-being of the United States if they were able to persuade American citizens that human dignity is both a given and an achievement. But that teaching has to be more fully recovered from papal encyclicals and the documents of Vatican Council II by the Catholic Church in the United States. When recovered, that twofold teaching will shore up respect for human rights.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_82"
    }
  }, [_vm._v("Human Rights and Natural Law")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_83"
    }
  }, [_vm._v("One need hardly make an argument that the themes of human dignity and human rights are closely linked. Scholars and nonscholars readily say that because human beings have dignity, they deserve the protection and\n"), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _vm._v("\nenjoyment of their many rights. What is not so clearly seen is the problematic side of commonly accepted human rights in the contemporary period. Some ways of conceiving and invoking rights are actually an affront to human dignity. Catholic social doctrine recognizes that the protection of rights upholds human dignity as long as people exercise them in the light of an objective moral standard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_84"
    }
  }, [_vm._v("The association of human dignity and natural law is not that common. Many would ask what the precise connection is between the two themes, not imagining that people could enhance their dignity by observing the natural law, as Catholic social doctrine holds. Under the influence of positivism, relativism, consequentialism, and historicism, many doubt that there is even such a thing as natural law. Catholic social doctrine teaches this hard-to-imagine truth and further holds that rights are based on the duties taught by the natural law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_85"
    }
  }, [_vm._v("The second half of this chapter will first summarize the Church's nuanced embrace of rights and then briefly explain what it means to speak of the natural law and how the observance of the natural law upholds human dignity. I will conclude this section with an explanation of historicism, the greatest threat to the acceptance of natural law, and then offer some thought on overcoming the lure of historicism by transcending the limits of one's culture through faith and reason. According to historicism, truth is simply a function of the time period in which you live. What is true for one culture may not be true for another. For historicists, truth is culture-bound; no one escapes the limits of one's culture.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_86"
    }
  }, [_vm._v("Human Rights")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_87"
    }
  }, [_vm._v("Between 1891 and the present the Catholic Church has developed an impressive body of teachings on human rights. In addition to Vatican Council II, popes Leo XIII, Pius XI, Pius XII, John XXIII, Paul VI, John Paul II, and Benedict XVI have all addressed the subject of human rights. Leo XIII's "), _c('i', [_vm._v("Rerum novarum")]), _vm._v(" introduced the language of rights into Catholic social doctrine, John XXIII's "), _c('i', [_vm._v("Pacem in terris")]), _vm._v(" has been called a human rights encyclical, and, as Avery Cardinal Dulles pointed out, John Paul II has placed more emphasis on human rights than any of his predecessors."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn47_ch01",
      "id": "ch01_fn47"
    }
  }, [_vm._v("47")])]), _vm._v(" On several occasions John Paul II has lavished fulsome praise\n"), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _vm._v("\non the United Nations' Universal Declaration of Human Rights. For example, at the very beginning of his address to the UN on October 5, 1995, the late pope said that the 1948 Declaration is “one of the highest expressions of the human conscience of our time.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn48_ch01",
      "id": "ch01_fn48"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_88"
    }
  }, [_vm._v("The Catholic emphasis on rights is readily understandable. The language of rights gives the Church a way to communicate with people in the present age. The language of virtue and duty is not always clear to people and sometimes raises fears of impending impingements on their freedoms. Respect for rights honors the dignity of the human person and promotes justice in society. When human rights are respected, people's lives are safe and secure and they enjoy a whole panoply of religious, economic, cultural, and political freedoms. The right to religious freedom is crucial for the mission of the Church and the well-being of the state. The Church needs freedom to bring its message of salvation, and individuals need freedom to practice their faith, from which flows justice and peace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_89"
    }
  }, [_vm._v("The language of rights, in addition, gives people a common idiom to discuss and recognize justice and injustice, and it accords with the emphasis in modernity on freedom. Where people enjoy the protection of rights, especially the right to religious liberty, governments cannot act in a tyrannical fashion. Rights can even be invoked when there is no agreement on their philosophical and theological foundation. What problems, then, can the protection of rights actually pose?")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_90"
    }
  }, [_vm._v("The simple answer is that, unlike virtue, rights can be misused. They have been increasingly invoked to justify abortion, euthanasia, suicide, physician-assisted suicide, and marriage between people of the same sex. People can appeal to their rights as a justification for not making any contributions to the communities in which they live. For example, people could say they have a right to their wealth and have no obligation to share it with others. Resolving conflicting rights claims can be difficult or impossible if there is no shared understanding of human dignity. In the United States there is no commonly accepted moral standard to resolve the dispute between those who advocate a right to life and those who insist on a right to choose abortion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_91"
    }
  }, [_vm._v("As mentioned in the introduction, natural rights (now called human rights) had an unsavory origin. Hobbes put forth his rights teachings as an alternative to the natural right and natural law of the premodern period.\n"), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _vm._v("\nHobbes famously said there is no "), _c('i', [_vm._v("summum bonum")]), _vm._v(" (highest good) to which people can look for guidance in the exercise of their rights. While Locke may have softened Hobbes's formulation, he still ratified the break with the ancients and left people without a "), _c('i', [_vm._v("summum bonum")]), _vm._v(" as the moral standard for their rights. Many scholars recognize that Locke's writings on rights had a deep influence on the American founding, but it wasn't exclusive, since the Christian convictions of the early Americans influenced the way they exercised their rights. It is only in recent times that rights have become more and more detached from Christianity and natural law standards, especially under the influence of historicism, relativism, and Nietzschean autonomy. These philosophical approaches actually call into question the foundation of rights and lead people to create their own values by an act of the will.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_92"
    }
  }, [_vm._v("In order to understand more exactly the problem of rights in the United States, it is helpful to examine parts of a book written by one of the great defenders of the Universal Declaration of Human Rights, Mary Ann Glendon."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn49_ch01",
      "id": "ch01_fn49"
    }
  }, [_vm._v("49")])]), _vm._v(" Her book "), _c('i', [_vm._v("Rights Talk: The Impoverishment of Political Discourse")]), _vm._v(" is an excellent introduction to thinking about the understanding and exercise of rights in America.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_93"
    }
  }, [_vm._v("Rights Talk")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_94"
    }
  }, [_vm._v("Mary Ann Glendon's "), _c('i', [_vm._v("Rights Talk")]), _vm._v(" should help American citizens understand why the preoccupation with creating and asserting rights undermines public morality. Glendon explains that the pervasive presence of rights talk in political, social, and cultural life causes difficulty in defining critical questions, finding common ground for discussion, and arriving at compromises in the face of intractable differences. Rights talk is silent “with respect to personal, civic, and collective responsibilities.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn50_ch01",
      "id": "ch01_fn50"
    }
  }, [_vm._v("50")])]), _vm._v(" Furthermore, “simplistic rights talk,” says Glendon, “simultaneously reflects and distorts American culture. It captures our devotion to individualism and liberty, but omits our traditions of hospitality and care for the community.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn51_ch01",
      "id": "ch01_fn51"
    }
  }, [_vm._v("51")])]), _vm._v(" Glendon, of course, doesn't argue for abandoning the American rights tradition. Rather, she is in favor of supplementing the\n"), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _vm._v("\nlanguage of rights with that of duty and responsibility in the law, public life, culture, and everyday life. This is not a utopian task, according to Glendon, because Americans already use the language of responsibility, such as duty and character, at home, in school, and at the workplace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_95"
    }
  }, [_vm._v("Glendon notes that legal concepts, especially rights talk, have permeated popular culture and political speech. She explains, “There is no more telling indicator of the extent to which legal notions have penetrated both popular and political discourse than our increasing tendency to speak of what is important to us in terms of rights, and to frame nearly every social controversy as a clash of rights.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn52_ch01",
      "id": "ch01_fn52"
    }
  }, [_vm._v("52")])]), _vm._v(" These two tendencies lead Americans to misperceive the social dimension of the human person. Under the influence of the rights paradigm people fail to recognize personal and collective duties.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_96"
    }
  }, [_vm._v("Our experience with abortion and property rights illustrates to me what Glendon is getting at. Focusing on the “absolute” right to property and to abortion, Americans may neglect their duty "), _c('i', [_vm._v("both")]), _vm._v(" to put their talents and material goods at the service of others "), _c('i', [_vm._v("and")]), _vm._v(" to avoid improper sexual relations. Otherwise stated, rights talk can impair self-knowledge. The assertion of rights often takes the place of giving reasons for attitudes, actions, or omissions. Describing social issues as a clash of rights, such as a woman's “right to choose abortion versus the fetus's right to life,” exacerbates conflict and inhibits perception of the alternatives to abortion as well as the gravity of the option for abortion. The duty to avoid killing is hardly discussed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_97"
    }
  }, [_vm._v("“Public rhetoric,” says Glendon, “regularly gloss[es] over the essential interplay between rights and responsibilities, independence and self-discipline, freedom and order[.]”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn53_ch01",
      "id": "ch01_fn53"
    }
  }, [_vm._v("53")])]), _vm._v(" American public officials and citizens often talk about rights as if they had no intrinsic relation to duties. Glendon astutely notes that even our founding documents, such as the Declaration of Independence and the Bill of Rights, have nothing comparable to the statements on duties in the Universal Declaration of Human Rights. The United Nations' Declaration says that “Everyone has duties to the community,” and that it is appropriate to place limitations on everyone's rights “for the purposes of securing due recognition and respect for the rights and freedoms of others and of meeting the just requirements of morality, public order, and the general welfare in a democratic society.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn54_ch01",
      "id": "ch01_fn54"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_98"
    }
  }, [_vm._v("Glendon contends that the pervasiveness of rights talk and the virtual absence of appeals to duty are weakening people's sense of responsibility. She goes so far as to say that simplistic rights talk “corrodes the fabric of beliefs, attitudes and habits upon which life, liberty, and all other individual and social goods ultimately depend.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn55_ch01",
      "id": "ch01_fn55"
    }
  }, [_vm._v("55")])]), _vm._v(" A liberal regime dedicated to the protection of rights depends on the presence of certain virtues in parents, workers, volunteers, citizens, and public officials.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_99"
    }
  }, [_vm._v("Glendon next seeks to explain “the persistence of absoluteness in our property rhetoric, and in our rights rhetoric in general[.]”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn56_ch01",
      "id": "ch01_fn56"
    }
  }, [_vm._v("56")])]), _vm._v(" In addressing this question she shows how the American way of life has been profoundly affected by the fascination with property and privacy or the right to be left alone. Glendon traces our love affair with property ultimately to John Locke, and more proximately to Blackstone's influence on those who drafted the Declaration of Independence, the Constitution, the "), _c('i', [_vm._v("Federalist Papers")]), _vm._v(", and the seminal decisions of the Marshall court. Locke taught that people own their bodies as “a God-given right” and that governments are instituted to protect life, liberty, and property (actually, under the term “property” Locke included life and liberty). Locke saw the natural right to property as a way of delegitimating the monarchy and of limiting government. For Blackstone, whose "), _c('i', [_vm._v("Commentaries")]), _vm._v(" educated countless American lawyers, property was an end unto itself, an absolute.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_100"
    }
  }, [_vm._v("The American fascination with property caused two important legal issues to be mishandled by the Supreme Court in the second half of the nineteenth century—one dealing with slavery, the other with the attempt to shape an American welfare state.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_101"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_102"
    }
  }, [_vm._v("In 1856, Dred Scott, who had entered federal court in Missouri as a man, left it as a piece of property, when the Missouri Compromise (prohibiting slavery in the territories) was held unconstitutional. From the latter years of the century up to the 1930s, the Supreme Court repeatedly invoked property rights (in an expansive form) to strike down a series of laws that, taken together, might have served to ease the transition here, as similar legislation did in Europe, to a modern mixed economy and welfare state."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn57_ch01",
      "id": "ch01_fn57"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_103"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_104"
    }
  }, [_vm._v("The Supreme Court invoked the right of employers and employees freely to make contracts and to control their property as a reason “for invalidating statutes that attempted to promote health and safety in the workplace, to protect female and child laborers, and to encourage the nascent labor movement.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn58_ch01",
      "id": "ch01_fn58"
    }
  }, [_vm._v("58")])]), _vm._v(" As is well known to students of constitutional law, the Supreme Court began a retreat from its exaggerated constitutional protection of property rights in the 1930s by upholding New Deal legislation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_105"
    }
  }, [_vm._v("After the Court abandoned the notion of absolute property rights, it eventually began to find absoluteness in the realm of personal rights. Glendon explains: “Much of the attention the Supreme Court once lavished on a broad concept of property, including the freedom of contract to acquire it, it now devotes to certain personal liberties that it has designated as ‘fundamental.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn59_ch01",
      "id": "ch01_fn59"
    }
  }, [_vm._v("59")])]), _vm._v(" The rhetoric of absolute property rights is now used in the area of personal liberties with the all-too-familiar result: lack of common sense in working out principled limitations on the exercise of personal liberties. As an example, Glendon mentions the extreme interpretations of the First and Second Amendments. One group of people does not want any restrictions on free speech and other forms of expression; another group favors “an absolute or nearly absolute, individual right” to bear and keep arms. Glendon notes, however, an intriguing irony: “many of the same people who claim that the right of free expression trumps a community's interest in regulating pornography, [argue] that the right to keep and bear arms has to be regulated for the sake of the general welfare.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn60_ch01",
      "id": "ch01_fn60"
    }
  }, [_vm._v("60")])]), _vm._v(" On the other hand, I would note that many people defending the absolute right to bear arms, such as semi-automatic weapons, are likely to defend the duty of the community to regulate pornography. Understanding the First Amendment or Second Amendment rights as absolutes causes substantial harm to the general welfare.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_106"
    }
  }, [_vm._v("Finally, I want to mention Glendon's explanation for the American tendency to absolutize rights. First, she suggests that the stark formulation of rights in the Declaration of Independence and the Bill of Rights has strongly influenced the American mind. Secondly, the Lockean story about property and Blackstone's “flights of fancy about property as absolute dominion stuck in American legal imaginations.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn61_ch01",
      "id": "ch01_fn61"
    }
  }, [_vm._v("61")])]), _vm._v(" Thirdly, Glendon mentions Tocqueville's observation that we are a lawyer-ridden society,\n"), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _vm._v("\ngreatly affected by the omnipresent legal culture. The “strategic exaggeration” and “overstatement” characteristic of lawyers in their adversarial roles have had an effect on most citizens. Citizens came to think about rights the way lawyers talk about them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_107"
    }
  }, [_vm._v("The question naturally arises whether the Catholic Church has sufficiently taken into account all the problems that the emphasis on rights can cause. In order to see how the Church initially arrived at the positions on rights articulated by Vatican II, John XXIII, et al., let us go back to the Church's first embrace of human rights in Pope Leo XIII's 1891 encyclical, "), _c('i', [_vm._v("Rerum novarum")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subhead2",
    attrs: {
      "id": "p_108"
    }
  }, [_vm._v("Rerum Novarum")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_109"
    }
  }, [_vm._v("As the Church's solution to the penurious condition of workers, Pope Leo XIII urged the acceptance of four general proposals: the protection of the right to private property; reliance on religion and the Church to teach and practice virtue; reliance on the state to assume responsibility for the common good; and cooperation among employers and associations for the material and spiritual well-being of workers and their families. Through these four proposals Leo XIII attempted to explain that the common good of a nation requires the protection of rights and the practice of virtue by all the citizens of the nation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_110"
    }
  }, [_vm._v("Anyone steeped in the theological and political thought of Augustine and Aquinas will be somewhat startled to find Leo XIII begin his encyclical with a defense of the right to private property. Leo's ringing endorsement of a natural and sacred right to property was a response to socialists who were proposing the abolition of private possessions in favor of state administration of all goods. Leo XIII and the socialists were in agreement on the problem—the penurious condition of the working class. Leo, however, believed that the socialist solution would ultimately harm workers by causing disorder in society, “a harsh and odious enslavement of citizens,” and a low economic standard of living for all."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn62_ch01",
      "id": "ch01_fn62"
    }
  }, [_vm._v("62")])]), _vm._v(" As an explanation of this last point Leo writes:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_111"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_112"
    }
  }, [_vm._v("If incentives to ingenuity and skill in individual persons were to be abolished, the very fountains of wealth would necessarily dry up; and the equality conjured up by the socialist imagination would, in reality, be nothing but uniform wretchedness and meanness for one and all without distinction."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn63_ch01",
      "id": "ch01_fn63"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_113"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_114"
    }
  }, [_vm._v("What's more, the socialist remedy is “openly in conflict with justice, inasmuch as nature confers on man the right to possess things privately as his own.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn64_ch01",
      "id": "ch01_fn64"
    }
  }, [_vm._v("64")])]), _vm._v(" Leo affirms a true and perfect right for a worker “to demand his wage” and “to spend it as he wishes.” A worker may also exercise full control over any land he may buy with his wages. Workers, says Leo, need the freedom to dispose of their own wages and land in order to have “the hope and the opportunity of increasing their property and securing advantages for themselves.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn65_ch01",
      "id": "ch01_fn65"
    }
  }, [_vm._v("65")])]), _vm._v(" Leo XIII clearly implies that society must rely on the self-interest of individuals to procure the necessities of life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_115"
    }
  }, [_vm._v("According to Leo XIII, the foundation of the right to private property is the law of nature and also divine law, which forbids us from even desiring what belongs to another. Civil laws have protected this right—even by force—and the practice of all ages points to “private possession as something best adopted to man's nature and to peaceful and tranquil living together.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn66_ch01",
      "id": "ch01_fn66"
    }
  }, [_vm._v("66")])]), _vm._v(" The Italian version of "), _c('i', [_vm._v("Rerum Novarum")]), _vm._v(" actually locates the existence of rights in the Gospel (“Ecco "), _c('i', [_vm._v("l'ideale dei diritti e doveri contenuto nel vangelo")]), _vm._v(". [sic]” Behold the ideal of rights and duties contained in the Gospel [sic].) The official Latin text reads "), _c('i', [_vm._v("Christiana philosophia")]), _vm._v(" (Christian Philosophy), and not Gospel."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn67_ch01",
      "id": "ch01_fn67"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_116"
    }
  }, [_vm._v("Both natural law and divine law, according to Leo XIII, teach that the individual "), _c('i', [_vm._v("qua")]), _vm._v(" individual has a right to property. Leo emphasizes this point by affirming that rights “have much greater validity when viewed as fitted into and connected with the obligations of human beings in family life.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn68_ch01",
      "id": "ch01_fn68"
    }
  }, [_vm._v("68")])]), _vm._v(" Leo XIII's initial position on the right to private property bears a striking resemblance to the teaching of John Locke, who is justly regarded as one of the fathers of capitalism. Leo "), _c('i', [_vm._v("sounds")]), _vm._v(" Lockean, especially in affirming that an individual may dispose of his wages and land as he wishes (“"), _c('i', [_vm._v("uti velit")]), _vm._v("”)"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn69_ch01",
      "id": "ch01_fn69"
    }
  }, [_vm._v("69")])]), _vm._v(" and by holding that individual rights are well grounded and solid apart from any connection to individual duties. But this is far from the pope's last word on the use of property. He goes on to affirm that the father of a family has a duty to provide for his offspring: “It is a most sacred law of nature that the father of a family see that his offspring are provided with all the necessities of life.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn70_ch01",
      "id": "ch01_fn70"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_117"
    }
  }, [_vm._v("Leo XIII's grounding of the right to private property in natural law\n"), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _vm._v("\nis a new development in the Catholic tradition. There simply is no statement about the right to property in the natural law teaching of Thomas Aquinas. Thomas Aquinas never argued that anyone had a natural right to property, much less “a sacred right.” He did say that “the division of possessions is not according to natural right but rather arose from human agreement…. Hence, the ownership of possessions is not contrary to natural right but an addition thereto devised by human reason.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn71_ch01",
      "id": "ch01_fn71"
    }
  }, [_vm._v("71")])]), _vm._v(" Aquinas defended private ownership not as a right, but simply as an efficient means of promoting industry, order, and peace. (It is important to note that Aquinas's reference to natural right is not at all a synonym for natural rights or human rights. The latter concepts refer to the subjective claims of the individual against other individuals and governmental power, while natural right refers to moral principles that have validity apart from the claims and opinions of individuals. Aquinas, in fact, never spoke of natural or human rights. The concept of universal natural rights, as we have seen, only emerged in the seventeenth century in the writings of Thomas Hobbes.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_118"
    }
  }, [_vm._v("Leo cites from Deuteronomy 5:21 to prove that divine law undergirds the right to property. That text reads: “Thou shall not covet thy neighbor's wife, nor his house, nor his field, nor his maid-servant, nor his ox, nor his ass, nor anything that is his.” The text affirms the duty of all not to desire the property or wife of another, and thus implies that people have a right to their lawful possessions. If the duty is observed, the people will enjoy the right to their property without disturbance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_119"
    }
  }, [_vm._v("The first section of "), _c('i', [_vm._v("Rerum Novarum")]), _vm._v(" is, of course, not the whole story on Leo XIII's view of property. In subsequent sections Leo puts forth the traditional Catholic teaching on property as expressed by Thomas Aquinas. Citing Thomas Aquinas, he writes that “man ought not regard external goods as his own but as common so that, in fact, a person should readily share them when he sees others in need. Wherefore, the apostle says: ‘Charge the rich of this world…to give readily to others.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn72_ch01",
      "id": "ch01_fn72"
    }
  }, [_vm._v("72")])]), _vm._v(" According to Leo, then, there really is no absolute right to dispose of wages, land, and personal property as one wishes ("), _c('i', [_vm._v("uti velit")]), _vm._v("). Rather, Christians have an obligation to use their property and talents for their own good and the good of others:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_120"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_121"
    }
  }, [_vm._v("whoever has received from the bounty of God a greater share of goods, whether corporeal and external, or of the soul, has received them for this purpose, namely, that he employ them for his own perfection, and likewise, as a servant of Divine Providence, for the benefit of others."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn73_ch01",
      "id": "ch01_fn73"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_122"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_123"
    }
  }, [_vm._v("In the section on the role of the state Leo XIII clearly says that duties owed to God take precedence over rights belonging to human beings. In this Leonine perspective it makes no sense to speak of individual rights to property apart from obligations to love God, self, and neighbor. "), _c('i', [_vm._v("Rerum Novarum")]), _vm._v(" teaches that nothing in life is more important than virtue. Those examining the example given by Jesus, says Leo, cannot fail to understand these truths:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_124"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_125"
    }
  }, [_vm._v("The true dignity and excellence of human beings consist in moral living, that is in virtue; virtue is the common inheritance of man, attainable equally by the humblest and the mightiest, by the rich and poor; and the reward of eternal happiness will follow upon virtue and merit alone, regardless of the person in whom they may be found."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn74_ch01",
      "id": "ch01_fn74"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_126"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_127"
    }
  }, [_c('i', [_vm._v("Rerum novarum")]), _vm._v(" also teaches that the attainment of the common good—including the material relief of the working class—can only be attained if people practice virtue at home, in the marketplace, and in positions of political and civic leadership. “Wherefore, if human society is to be healed, only a return to Christian life and practices will heal it” ("), _c('i', [_vm._v("Rerum novarum")]), _vm._v(", no. 41), ("), _c('i', [_vm._v("revocatio vitae institutorumque Christianorum; il ritorno alla vita e ai costumi Christiani")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn75_ch01",
      "id": "ch01_fn75"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_128"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_129"
    }
  }, [_vm._v("[S]ince religion alone, as we said in the beginning, can remove the evil root and branch, let all reflect upon this. First and foremost, Christian morals must be re-established, without which even the weapons of prudence, which are considered especially effective, will be of no avail to secure well being."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn76_ch01",
      "id": "ch01_fn76"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_130"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_131"
    }
  }, [_vm._v("Pope Leo XIII's attempt to use and tame the modern teaching on rights was a grand effort. Leo really tried to integrate the premodern virtue tradition with the modern rights tradition stemming from Thomas Hobbes and John Locke. This is an immense task, since the originator\n"), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _vm._v("\nof rights doctrines, Thomas Hobbes, as previously mentioned, completely divorced rights from any notion of a "), _c('i', [_vm._v("summum bonum")]), _vm._v(". In other words, for Hobbes, the exercise of rights was not guided by the highest good. Ernest Fortin discusses the difference between the premodern tradition of virtue and the modern tradition of rights in this most illuminating paragraph:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_132"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_133"
    }
  }, [_vm._v("The passage from natural law to natural rights and later (once “nature” had fallen into disrepute) to “human” rights represents a major shift, indeed "), _c('i', [_vm._v("the")]), _vm._v(" paradigm shift in our understanding of justice and moral phenomena generally. Prior to that time, the emphasis was on virtue and duty, that is to say, on what human beings owe to other human beings or to society at large rather than on what they can claim from them."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn77_ch01",
      "id": "ch01_fn77"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_134"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_135"
    }
  }, [_vm._v("According to a prevalent understanding of rights, individuals are free to create their own values. In one of their abortion cases, "), _c('i', [_vm._v("Planned Parenthood v. Casey")]), _vm._v(" (1992), the U.S. Supreme Court said, “At the heart of liberty is the right to define one's own concept of existence, of meaning, of the universe and of the mystery of human life.” Fortin rightly notes that this much-cited sentence has striking implications.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_136"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_137"
    }
  }, [_vm._v("The only just society is the one that grants to each individual as much freedom as is compatible with the freedom of every other individual. It has nothing to say about the good life and is not concerned with the promotion of virtue. Its sole function is to insure the safety of its members and provide for their comfort."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn78_ch01",
      "id": "ch01_fn78"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_138"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_139"
    }
  }, [_vm._v("These theoretical observations, as well as the experience of living in America, show that rights are not that easily integrated into the premodern virtue tradition. Rights tend to be understood and lived as though they are divorced from the highest good. Not that everyone understands them that way!")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_140"
    }
  }, [_vm._v("For many years I have been asking my students—who are mostly Catholic—why they respect the rights of others. They invariably respond, “So that other people will respect mine.” They hardly ever say because it is the right or virtuous thing to do. Yet, I believe that many of them do respect rights because it is the right or virtuous thing to do, but they cannot speak in the language of virtue.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_141"
    }
  }, [_vm._v("Vatican Council II did place rights in a context where they could be integrated into the premodern virtue tradition. "), _c('i', [_vm._v("Gaudium et spes")]), _vm._v(" says:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_142"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_143"
    }
  }, [_vm._v("Therefore, by virtue of the gospel committed to her, the Church proclaims the rights of man. She acknowledges and greatly esteems the dynamic movements of today by which these rights are everywhere fostered. Yet these movements must be penetrated by the spirit of the gospel and protected against any kind of false autonomy. For we are tempted to think that our personal rights are fully insured only when we are exempt from every requirement of divine law. But in this way the dignity of the human person is by no means saved; on the contrary, it is lost."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn79_ch01",
      "id": "ch01_fn79"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_144"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_145"
    }
  }, [_vm._v("This approach would put rights in the kind of framework—teleological, to be exact—that would enable Catholics to integrate rights doctrines with traditional teachings on virtue. This passage clearly reveals the Church's awareness that people are tempted to invoke rights as a way to justify an autonomy independent of objective moral norms. This false autonomy would include the kind promoted by relativism and historicism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_146"
    }
  }, [_vm._v("In "), _c('i', [_vm._v("Pacem in terris")]), _vm._v(" Pope John XXIII insists on grounding human rights in the natural law and keeping them linked to duties.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_147"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_148"
    }
  }, [_vm._v("For every fundamental human right draws its indestructible moral force from the natural law, which in granting it imposes a corresponding obligation. Those, therefore, who claim their own rights, yet altogether forget or neglect to carry out their respective duties, are people who build with one hand and destroy with the other."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn80_ch01",
      "id": "ch01_fn80"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_149"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_150"
    }
  }, [_vm._v("By teaching that the foundation of human rights is natural law and that a person's duties remain in the age of rights, John XXIII reveals that his understanding of rights differs from that of Hobbes and Locke. Until these teachings of Vatican Council II and of Pope John XXIII find their way into local catechisms, Sunday homilies, and subsequent Church documents, most Catholics will most likely not understand their full import.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_151"
    }
  }, [_vm._v("People with a secular perspective on rights would have a great deal of difficulty accepting that rights are subordinate to the divine law, or otherwise stated, the highest good. The Church could perhaps persuade some non-Catholics and nonreligious people that rights must be exercised in\n"), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _vm._v("\nthe light of some shared understanding of the good, however minimal. The understanding and observance of the natural law is an excellent way of coming to an agreement on common standards.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_152"
    }
  }, [_vm._v("Natural Law")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_153"
    }
  }, [_vm._v("“The expression ‘natural law,’” explains Ernest Fortin, “is often loosely applied to any theory that holds to objective standards of morality. In its proper sense, it designates a moral law that both exists by nature and is known by nature to be binding on everyone.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn81_ch01",
      "id": "ch01_fn81"
    }
  }, [_vm._v("81")])]), _vm._v(" Many people believe that there is a law higher than the civil law to which people owe allegiance and to which they can be held accountable. Consider the conviction of war criminals at the Nuremberg International War-Crimes Trials in 1945–46. Defendants could not claim that they were simply obeying the law in Nazi Germany. They were judged to be guilty for not following a higher law, a natural law that had to take precedence over unjust Nazi laws.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_154"
    }
  }, [_vm._v("In his famous “Letter from Birmingham City Jail” Martin Luther King, Jr., notes Fortin, cited Thomas Aquinas “in support of the view that a human law not rooted in eternal and natural law is an unjust law.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn82_ch01",
      "id": "ch01_fn82"
    }
  }, [_vm._v("82")])]), _vm._v(" The Reverend King, of course, was protesting against laws mandating segregation and other forms of racial injustice. King composed this letter on April 16, 1963, in response to a letter written on April 12 by eight white Alabama clergymen. They argued that King and others should seek relief in the courts, avoiding any demonstrations in the streets against unjust laws, however peaceful. In my judgment, King's invocation of Thomas Aquinas's thought was wholly justified and remains a reminder that all human laws should be evaluated in the light of the eternal and natural law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_155"
    }
  }, [_vm._v("The description of racism and its effects in Dr. King's “Letter” is actually a proof that the natural law is a reality. Every person of good will senses that legally enforced racism must contradict a higher law. Just let us listen to Dr. King's words explaining why African-Americans are tired of waiting to be treated justly and decently:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_156"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_157"
    }
  }, [_vm._v("I guess it is easy for those who have never felt the stinging darts of segregation to say, “Wait.” But when you have seen vicious mobs lynch your mothers and fathers at will and drown your sisters and brothers at whim; when\n"), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _vm._v("\nyou have seen hate-filled policemen curse, kick, brutalize and even kill your black brothers and sisters with impunity; when you see the vast majority of your twenty million Negro brothers in an airtight cage of poverty in the midst of an affluent society; when you suddenly find your tongue twisted and your speech stammering as you seek to explain to your six-year-old daughter why she can't go to the public amusement park that has just been advertised on television, and see tears welling up in her little eyes when she is told that Fun-town is closed to colored children, and see the depressing clouds of inferiority begin to form in her little mental sky, and see her begin to distort her little personality by unconsciously developing a bitterness toward white people; when you have to concoct an answer for a five-year-old son asking in agonizing pathos: “Daddy, why do white people treat colored people so mean?”; when you take a cross-country drive and find it necessary to sleep night after night in the uncomfortable corners of your automobile because no motel will accept you; when you are humiliated day in and day out by nagging signs reading “white” and “colored”; when your first name becomes “nigger” and your middle name becomes “boy” (however old you are) and your last name becomes “John,” and when your wife and mother are never given the respected title “Mrs.”; when you are harried by day and haunted by night by the fact that you are a Negro, living constantly at tiptoe stance never quite knowing what to expect next, and plagued with inner fears and outer resentments; when you are forever fighting a degenerating sense of “nobodiness”; then you will understand why we find it difficult to wait."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn83_ch01",
      "id": "ch01_fn83"
    }
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_158"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_159"
    }
  }, [_vm._v("In order to clarify further the meaning of the natural law, I will turn now to Thomas Aquinas and to John Paul II's "), _c('i', [_vm._v("Veritatis splendor")]), _vm._v(". Aquinas argues that God governs the whole universe by divine reason and divine providence. “This mode of ordering things ("), _c('i', [_vm._v("ratio ordinis rerum")]), _vm._v(") toward an end is…in God called providence.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn84_ch01",
      "id": "ch01_fn84"
    }
  }, [_vm._v("84")])]), _vm._v(" God's providential government has the nature of law, because law is “nothing else but a dictate of practical reason from the ruler who governs a perfect community.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn85_ch01",
      "id": "ch01_fn85"
    }
  }, [_vm._v("85")])]), _vm._v(" This law is called eternal because God “is not subject to time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_160"
    }
  }, [_vm._v("The rational creature participates in this eternal law by having a “natural inclination to its proper act and end.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn86_ch01",
      "id": "ch01_fn86"
    }
  }, [_vm._v("86")])]), _vm._v(" It is God's providence that gives man his end and a natural inclination thereto. Because man is free,\n"), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _vm._v("\nhe shares further in God's providence by providing for himself and others in accordance with his natural inclinations. That is to say, he can make moral choices and laws on the basis of his God-given natural end. Otherwise stated, “Since law is a rule or measure, there are two ways it can be in someone: in one way, as the one ruling and measuring; in the other way, as the one ruled and measured, since a thing is ruled or measured, insofar as it partakes of the rule or measure.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn87_ch01",
      "id": "ch01_fn87"
    }
  }, [_vm._v("87")])]), _vm._v(" Aquinas is saying that human beings are ruled or measured by God; he imprints on them their end and natural inclinations to that end. They, in turn, can rule or measure on the basis of who they are as a result of God's providential government. Human beings don't create an end for themselves, as Nietzsche and Sartre maintained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_161"
    }
  }, [_vm._v("Aquinas holds that a human being has three natural inclinations, which he immediately perceives as good: to stay alive, to procreate and educate children, and both to seek the truth and to live in community. The first inclination is common to all living beings, the second to animals and man, and the third is proper to man. As the first precept of the natural law is that “good is to be done and pursued, and evil is to be avoided,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn88_ch01",
      "id": "ch01_fn88"
    }
  }, [_vm._v("88")])]), _vm._v(" a human being tends to act in accordance with his natural inclinations and to avoid acting against them. A person naturally steps out of the way of a car about to hit him, a mother naturally feeds her baby, and human beings naturally seek the company of others. Behaving in such a way, of course, upholds and enhances the dignity of human persons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_162"
    }
  }, [_vm._v("We all have noticed, however, that human beings don't always act according to their natural inclinations. Mothers sometimes kill their babies, people kill themselves or take unjustifiable risks showing little regard for their life or health, parents neglect the education of their children, and nearly everyone shows some disregard for the truth to a greater or lesser degree. As a response to this obvious fact, Aquinas points out that “in some the reason is perverted by passion, or evil custom, or an evil natural disposition ("), _c('i', [_vm._v("ex mala habitudine naturae")]), _vm._v("); thus formerly, theft, although it is expressly contrary to the natural law, was not considered wrong among the Germans, as Julius Caesar relates ("), _c('i', [_vm._v("De Bello Gallico")]), _vm._v(", VI).”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn89_ch01",
      "id": "ch01_fn89"
    }
  }, [_vm._v("89")])]), _vm._v(" Today, abortion, euthanasia, “hooking up” or fornication, pornography, and same-sex marriage are not considered wrong by many people, although they are forbidden by the fifth and sixth commandments. They may have come to\n"), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _vm._v("\nthis opinion under the influence of passion or of bad mores receiving approval in the culture. A pronounced disposition to excess in the area of sex or anger, not corrected by education, could lead people to fornication, adultery, or to aggressive behavior toward one's family, friends, and neighbors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_163"
    }
  }, [_vm._v("It is not hard to understand that the passions and habits generated by the culture could induce people to disregard the commandments on the second table of the Decalogue (commandments four through ten). Unjustifiable killing, such as abortion and euthanasia, and various forms of unchastity can become so routine under the influence of the culture that their wrongness is only dimly perceived or not at all. If this can and does happen, how can Aquinas still speak of a natural law impressed on the mind and heart of all human beings? Despite all the deviations, people still tend to act in accordance with their three natural inclinations, and the first precept of the natural law, do good and avoid evil, is rarely denied, though people disagree about the meaning of good and evil. Aquinas recognizes that the perception and observance of the natural law sometimes depend on instruction by the wise and the practice of the virtues. In other words, wisdom and the habit of virtue offer protection against the onslaught of disordered passions and bad habits that find approval in the culture."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn90_ch01",
      "id": "ch01_fn90"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_164"
    }
  }, [_vm._v("Virtue is not foreign to a human being, because “there is in every man a natural inclination to act according to reason: and this is to act according to virtue. Consequently, considered thus, all acts of virtue are prescribed by the natural law, since each one's reason naturally dictates to him to act virtuously.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn91_ch01",
      "id": "ch01_fn91"
    }
  }, [_vm._v("91")])]), _vm._v(" Aquinas qualifies this statement by adding that “many things are done virtuously, to which nature does not incline at first; but which through the inquiry of reason, have been found by men to be conducive to well-being.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn92_ch01",
      "id": "ch01_fn92"
    }
  }, [_vm._v("92")])]), _vm._v(" Aquinas seems to be saying that inquiries carried out by the wise over the centuries will further increase knowledge of virtuous acts in the less learned majority. In a later discussion of the moral precepts of the Old Law, including the Ten Commandments, Aquinas says that everyone can recognize the validity of the fourth, fifth, and seventh commandments, but some aspects of the law of nature are only known by the wise and those taught by the wise."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn93_ch01",
      "id": "ch01_fn93"
    }
  }, [_vm._v("93")])]), _vm._v(" But, as we have already seen, people may even fail to recognize the validity of the seventh commandment\n"), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _vm._v("\nand presumably the other commandments on the second table of the Decalogue. Aquinas, nevertheless, thinks that all seven commandments on the second table of the Decalogue are part of the natural law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_165"
    }
  }, [_vm._v("In short, to act fully in accord with their natural inclinations, human beings need instruction and training in virtue. It is possible, but very difficult, for human beings to know the truths about God, including the truth that God is the author of the natural law; thus they need instruction by divine revelation. Aquinas explains:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_166"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_167"
    }
  }, [_vm._v("Even as regards those truths about God which human reason could have discovered, it was necessary that man should be taught by a divine revelation; because the truth about God such as reason could discover, would only be known by a few, and that after a long time, and with the admixture of many errors."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn94_ch01",
      "id": "ch01_fn94"
    }
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_168"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_169"
    }
  }, [_vm._v("Aquinas believes training in virtue is also necessary because the effects of sin inhibit perception of the natural law. In other words, the law of nature is opposed by the law of concupiscence, that disordered desire caused by original sin and personal sin. Toward the end of his life Aquinas went so far as to say, “Since then the law of nature was destroyed by concupiscence, man needed to be brought back to works of virtue, and to be drawn away from vice: for which purpose he needed the written law.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn95_ch01",
      "id": "ch01_fn95"
    }
  }, [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_170"
    }
  }, [_vm._v("A contemporary author, J. Budziszewski, has an insightful way of explaining what is needed for an accurate perception of the natural law.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_171"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_172"
    }
  }, [_vm._v("Even insights into “what we can't not know” require the assistance of others, for a good deal of what we know is latent; we may not realize "), _c('i', [_vm._v("what it is")]), _vm._v(" that we know, and we are certainly unlikely to know all its presuppositions and implications. Most of the “others” on whose assistance we rely will belong to previous generations, because people of our own time are likely to have the same blind spots that we do."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn96_ch01",
      "id": "ch01_fn96"
    }
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_173"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_174"
    }
  }, [_vm._v("This means, of course, that the grand tradition of learning, found especially in great texts or masterworks, will be indispensable for those seeking knowledge of the natural law. For example, Aristotle's "), _c('i', [_vm._v("Ethics")]), _vm._v(" and\n"), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }), _vm._v("\nSt. Augustine's "), _c('i', [_vm._v("Confessions")]), _vm._v(" have insights into the effect of good and bad habits on the perception and acceptance of truth that most individuals could not hope to discover on their own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_175"
    }
  }, [_vm._v("A second point made by Budziszewski is that “bad living” can blot out moral truths derived from first principles. In other words, the mind and the character work together. The mind of people who live badly will be hindered in its perception of the natural law—hence the importance of the tradition in the form of moral education. This kind of education not only instructs, but also exhorts. Budziszewski explains,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_176"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_177"
    }
  }, [_vm._v("Moral education serves at least five purposes. It reinforces what we know, because the mere fact that we know something is wrong is not enough to keep us from doing it. It elicits what we know, because we know many things without noticing that we know them. It guards what we know, because although deep conscience cannot err, surface conscience can err in all too many ways. It builds upon what we know, because only the most general and basic matters of right and wrong are known to us immediately, and second knowledge must be added to first. Finally, it confronts us about what we know, because sometimes we need to be told “You know better.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn97_ch01",
      "id": "ch01_fn97"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_178"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_179"
    }
  }, [_vm._v("This combination of instruction and exhortation corresponds to the New Testament's approach to moral matters. St. Paul, for example, is always instructing and exhorting his listeners.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_180"
    }
  }, [_vm._v("Budziszewski's distinction between deep conscience (what Aquinas called "), _c('i', [_vm._v("synderesis)")]), _vm._v(" and surface conscience ("), _c('i', [_vm._v("conscientia")]), _vm._v(") also helps to explain why people have difficulty accurately perceiving the natural law. Surface conscience misses the mark, argues Budziszewski, because of insufficient experience, poor reasoning ability, unwillingness to reason because of sloth, corrupt customs, disordered passions, fear of discovering the truth, misleading ideologies, and stubborn desire to do what one wants despite its wrongness. Deep conscience gives everyone “knowledge of basic goods, of formal norms, and of everyday rules.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn98_ch01",
      "id": "ch01_fn98"
    }
  }, [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_181"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_182"
    }
  }, [_vm._v("Deep conscience is the reason why even a man who tells himself there is no right and wrong may shrink from committing murder; why even a man who murders may suffer the pangs of remorse; and why even a man who has deadened himself to remorse shows other symptoms of deep-buried guilty knowledge."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn99_ch01",
      "id": "ch01_fn99"
    }
  }, [_vm._v("99")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_183"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_184"
    }
  }, [_vm._v("Budziszewski does concede that people still can frustrate deep conscience by lying to themselves, by denying that they know what they really do. How often this may happen Budziszewski does not presume to say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_185"
    }
  }, [_vm._v("Despite the perception problems caused by imperfect reason and disordered desire, at least the seeds of the natural law are instilled in the human mind. Human beings can usually see that “the natural condition of man is one of participation in a higher norm. Man has liberty to direct himself because he is first directed by another.” In other words, to use Thomistic language, “The human reason is a measured measure ("), _c('i', [_vm._v("mensura mensurata")]), _vm._v(") not a measuring measure ("), _c('i', [_vm._v("mensura mensurans")]), _vm._v("). Having received a law the human mind can go on to judge and command according to that law.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn100_ch01",
      "id": "ch01_fn100"
    }
  }, [_vm._v("100")])]), _vm._v(" In simple language, a human being naturally has a sense that he doesn't make up the rules he lives by, but knows intuitively that he is not his own god. He discovers rather than creates or invents the principles on the basis of which he will direct and live his life. Because people no longer see this point clearly, one of the things the Church needs to do is to show that being commanded by God is the natural condition of a human being and not a teaching strategy invented by the Church in order to control people."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn101_ch01",
      "id": "ch01_fn101"
    }
  }, [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_186"
    }
  }, [_vm._v("Genesis 2:17 teaches human beings that their natural condition is one of receiving instruction in how to live. In "), _c('i', [_vm._v("Veritatis splendor")]), _vm._v(" John Paul II comments on Genesis 2:17 as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_187"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_188"
    }
  }, [_vm._v("by forbidding man to “eat of the tree of the knowledge of good and evil,” God makes it clear that man does not originally possess such “knowledge” as something properly his own, but only participates in it by the light of natural reason and of Divine Revelation, which manifests to him the requirements and the promptings of eternal wisdom."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn102_ch01",
      "id": "ch01_fn102"
    }
  }, [_vm._v("102")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_189"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_190"
    }
  }, [_vm._v("So, revelation reinforces the teaching given by the law that God impresses on every mind about the necessity of achieving perfection in a prescribed way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_191"
    }
  }, [_vm._v("The pope is well aware that today's cultural climate encourages people to “"), _c('i', [_vm._v("exalt freedom to such an extent that it becomes an absolute, which would then be the source of values")]), _vm._v(".”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn103_ch01",
      "id": "ch01_fn103"
    }
  }, [_vm._v("103")])]), _vm._v(" Following in the footsteps of Nietzsche, individuals would “"), _c('i', [_vm._v("determine what is good or evil")]), _vm._v(".” Otherwise stated, people are encouraged to think that their moral judgments are necessarily true because\n"), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }), _vm._v("\nthey stem from their conscience. In this perspective, conscience becomes a kind of oracle that makes pronouncements instead of a herald, which announces the message transmitted by reason and divine revelation. In other words, “there is a tendency to grant to the individual conscience the prerogative of independently determining the criteria of good and evil and then acting accordingly…. Taken to its extreme consequences, this individualism leads to a denial of the very idea of human nature.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn104_ch01",
      "id": "ch01_fn104"
    }
  }, [_vm._v("104")])]), _vm._v(" Having a human nature means that you can't simply create your own values, but you must live in accordance with your nature. For example, you can't decide to love no one without doing harm to yourself, no matter how “sincere” you are. In other words, the human mind is not a measuring measure, but a measured measure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_192"
    }
  }, [_vm._v("Reason has to discern the moral law and then apply it to situations. All moral law has its origin in God, but the natural moral law can be discerned by the human heart. Quoting Aquinas, the pope says it “‘is nothing other than the light of understanding infused in us by God, whereby we understand what must be done and what must be avoided. God gave this light and this law to man at creation.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn105_ch01",
      "id": "ch01_fn105"
    }
  }, [_vm._v("105")])]), _vm._v(" When our practical reason grasps this natural law, it participates “in the wisdom of the divine Creator and Lawgiver.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn106_ch01",
      "id": "ch01_fn106"
    }
  }, [_vm._v("106")])]), _vm._v(" What Aquinas and John Paul II are saying is that the natural condition of human beings is to obey the divine Lawgiver because he prescribes what is good for them. The only other real alternative, as mentioned, is to reject guidance by natural law and divine revelation in favor of an autonomy that entitles one to create values out of whole cloth. The choice is either participated theonomy or unbounded freedom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_193"
    }
  }, [_vm._v("The pope describes God's wisdom as providence because he “cares for man not ‘from without,’ through the laws of physical nature, but ‘from within,’ through reason, which, by its natural knowledge of God's eternal law, is consequently able to show man the right direction to take in his free actions.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn107_ch01",
      "id": "ch01_fn107"
    }
  }, [_vm._v("107")])]), _vm._v(" There is a right direction because the rational creature has “‘its proper act and end.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn108_ch01",
      "id": "ch01_fn108"
    }
  }, [_vm._v("108")])]), _vm._v(" In other words, not just any attitude or act perfects the human agent, but only those attitudes and acts in accord\n"), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _vm._v("\nwith the image of God that man is. God created human beings to seek truth, not falsehood; virtue, not vice; holiness, not depravity. We abuse our freedom if we reject our participation in the eternal law, that is to say, the natural law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_194"
    }
  }, [_vm._v("Natural law is called a law because it is “‘the reason or the will of God, who commands us to respect the natural order and forbids us to disturb it.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn109_ch01",
      "id": "ch01_fn109"
    }
  }, [_vm._v("109")])]), _vm._v(" It would not be called a law unless God had authority over us as our Creator and lawgiver. It could not be called law if we were our own supreme legislators who decided what is good or bad without any guidance from a higher reason.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_195"
    }
  }, [_vm._v("Two reasons that the teaching on natural law seems wrongheaded to people, according to John Paul II, are contemporary convictions about the nature of the body and the cultural conditioning of all norms. The pope explains:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_196"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_197"
    }
  }, [_vm._v("A freedom which claims to be absolute ends up treating the human body as a raw datum, devoid of any meaning and moral goods [or values] until freedom has shaped it in accordance with its design. Consequently, human nature and the body appear as "), _c('i', [_vm._v("presuppositions or preambles")]), _vm._v(", materially "), _c('i', [_vm._v("necessary")]), _vm._v(" for freedom to make its choice, yet extrinsic to the person, the subject and the human act."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn110_ch01",
      "id": "ch01_fn110"
    }
  }, [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_198"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_199"
    }
  }, [_vm._v("This means, for example, that the human body gives no indication as to the morality or immorality of contraception, direct sterilization, or homosexual relations. Only the person matters, and the body is not considered to be an essential part of the person. In addition, if all moral norms are culturally conditioned, then human beings can't make decisions on the basis of some universal norm. Joseph Fuchs is one of those Catholic moral theologians who has taken this position. He writes, “Neither the Hebrew Bible nor the New Testament produces statements that are independent of culture and thus universal and valid for all time; nor can these statements be given by the church or its Magisterium.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn111_ch01",
      "id": "ch01_fn111"
    }
  }, [_vm._v("111")])]), _vm._v(" Human beings must freely determine the meaning of their behavior without any guidance from the body, human nature, moral norms that transcend time and place, or revelation. What this means in practice is that most people will\n"), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }), _vm._v("\nadopt the mores taught by the opinion makers of the contemporary culture, as Tocqueville noted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_200"
    }
  }, [_vm._v("The position that Joseph Fuchs and others have advocated can be understood in the light of what John Paul II said about historicism in "), _c('i', [_vm._v("Fides et ratio")]), _vm._v(". “The fundamental claim of historicism…. is that the truth of a philosophy is determined on the basis of its appropriateness to a certain period and a certain historical purpose. At least implicitly, therefore, the enduring validity of truth is denied. What was true in one period, historicists claim, may not be true in another.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn112_ch01",
      "id": "ch01_fn112"
    }
  }, [_vm._v("112")])]), _vm._v(" So what the Bible said in the past was true for its time period, but not for all time. Furthermore, historicist theologians such as Fuchs claim that the Magisterium or the teaching authority of the Church can never definitively settle any moral issue with authoritative teaching. This is because reality supposedly doesn't allow such a thing.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_201"
    }
  }, [_vm._v("The Practical Effect of Historicism")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_202"
    }
  }, [_vm._v("Given the situation in the universities and in the culture, John Paul II's comments on historicism are especially noteworthy. If historicism is true, then it does not make sense to read classic texts of the past in order to find perennial wisdom about important matters. The acceptance of historicism really leads people to accept either the opinions of the majority or the reigning opinions of the movers and shakers in society. It is also a form of historicism to “think that truth is born of consensus and not of consonance between intellect and objective reality.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn113_ch01",
      "id": "ch01_fn113"
    }
  }, [_vm._v("113")])]), _vm._v(" Consensus would obviously depend on locale and the time period.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_203"
    }
  }, [_vm._v("C. S. Lewis captured the effect of historicism on scholarship in a passage from his "), _c('i', [_vm._v("Screwtape Letters")]), _vm._v(". Screwtape explains to his nephew that scholars can be deterred from seeking truth in old books by inculcating in them what is called the historical point of view.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_204"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_205"
    }
  }, [_vm._v("The Historical Point of View, put briefly, means that when a learned man is presented with any statement in an ancient author, the one question he never asks is whether it is true. He asks who influenced the ancient writer, and how far the statement is consistent with what he said in other books and what phase in the writer's development or in the general history of thought it illustrates, and how often it has been misunderstood (especially by the learned man's colleagues) and what the general course of criticism on it has been for\n"), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }), _vm._v("\nthe last ten years, and what is the “present state of the question.” To regard the ancient writer as a possible source of knowledge—to anticipate that what he said could possibly modify your thoughts or your behavior—this would be rejected as unutterably simple-minded."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn114_ch01",
      "id": "ch01_fn114"
    }
  }, [_vm._v("114")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_206"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_207"
    }
  }, [_vm._v("With this kind of approach “scholarship becomes an immunization against the truth,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn115_ch01",
      "id": "ch01_fn115"
    }
  }, [_vm._v("115")])]), _vm._v(" since it is unscholarly to ask whether Dante or Shakespeare have actually seen something that is true for all time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_208"
    }
  }, [_vm._v("The effect of historicism on people's attitude toward the culture in which they live is visible in the common opinion that all cultures are to be respected. In other words, value judgments are to be avoided. A historicist mentality, then, leads people to bow down before what becomes authoritative in a culture, simply because it is experienced as imposing and powerful. Historicism reinforces the persuasiveness of the old adage: “to get along, go along.” A philosophical principle now supports the all-too-human tendency to adapt to one's surroundings, even if that means giving up or blunting the love of truth and living immorally.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_209"
    }
  }, [_vm._v("In order to clarify further the meaning and implication of historicism for everyday life, I will present Pope John Paul II's alternative way of appreciating and evaluating any particular culture. The pope says that Christians always experience their faith as imbued in a culture, and their faith, in turn, forms the local culture over a period of time. His fundamental conviction, however, is that cultures are a mixture of truth and error. “When cultures are deeply rooted in human nature ["), _c('i', [_vm._v("natura humana")]), _vm._v(", mistranslated as ‘experience’ in the Vatican translation] they show forth the human being's characteristic openness to the universal and the transcendent.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn116_ch01",
      "id": "ch01_fn116"
    }
  }, [_vm._v("116")])]), _vm._v(" When grounded in human nature, cultures “offer different paths to truth” and thereby are able to incline human beings to live well, that is, in the truth. But with respect to God's revelation every culture falls short. “No one culture can ever become the norm of judging, much less the ultimate norm of truth with regard to God's revelation.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn117_ch01",
      "id": "ch01_fn117"
    }
  }, [_vm._v("117")])]), _vm._v(" The Gospel message, in fact, “is the true form of liberation from all the disorders caused by sin and is likewise the call to the fullness of truth.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn118_ch01",
      "id": "ch01_fn118"
    }
  }, [_vm._v("118")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }), _vm._v("\nOtherwise stated, John Paul II is saying that every culture will have something missing and, therefore, must remain open to correction and fulfillment. So, even the very best cultures imaginable, those rooted in human nature, will fall short of the full truth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_210"
    }
  }, [_vm._v("While appreciating the valuable contributions that rich cultures can offer to humanity, he still says that no “particular cultural tradition should remain closed in its difference and affirm itself by opposing other traditions.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn119_ch01",
      "id": "ch01_fn119"
    }
  }, [_vm._v("119")])]), _vm._v(" In making this statement John Paul II shows his awareness that cultures have the tendency to love their own way more than the truth. Today, of course, some prevailing opinions justify this kind of complacency by urging a general respect for all cultures, whatever their characteristics. What else is there to do if it is impossible to arrive at truth by philosophical inquiry and acceptance of revelation? People adversely affected by closed-minded cultures will not be open to learn from the great writers of the past, to perceive the truths in other religious traditions, or to hear the Gospel message of salvation. To illustrate the implications of his thought, the pope says that “at this time it is the duty of Christians, especially Indian Christians, to draw from the rich heritage [of the religious and philosophical thought in the nation of India] those elements compatible with their faith in order to enrich Christian doctrine.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn120_ch01",
      "id": "ch01_fn120"
    }
  }, [_vm._v("120")])]), _vm._v(" This means that Christians living in any culture should be open to whatever truth is found in the prevailing mores, or in any particular philosophy or religious tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_211"
    }
  }, [_vm._v("Transcending Culture through Faith and Reason")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_212"
    }
  }, [_vm._v("John Paul II is fully aware how difficult it is for people to give up their erroneous opinions and practices. Even the Bible shows that the ancient Israelites had to engage in a laborious struggle to overcome the limitations of their own culture. In commenting on "), _c('i', [_vm._v("Fides et ratio")]), _vm._v(", Cardinal Ratzinger nicely clarifies John Paul II's thought in the following paragraph:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_213"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_214"
    }
  }, [_vm._v("The Bible is not simply the expression of the culture of the people of Israel but rather manifests a constant conflict with the completely natural desire of the people of Israel to be only themselves, to shut themselves in their own culture. Faith in God and their yes to the will of God are wrested from them against their own wishes…. Israel's faith requires a continual self-transcendence, an overcoming of its own culture, in order to open itself and\n"), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }), _vm._v("\nenter into the expansiveness of a truth common to all. The books of the Old Testament…possess their own originality in this struggle of faith against particularity, the process of taking leave of what is their own, which begins with Abraham's departure on his journey."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn121_ch01",
      "id": "ch01_fn121"
    }
  }, [_vm._v("121")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_215"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_216"
    }
  }, [_vm._v("To understand more fully this wonderfully illuminating paragraph, think of the people's inclination to make and worship idols shortly after the exodus from Egypt or the continuous efforts of the prophets to call Israel back to the God of Abraham, Isaac, and Jacob. The struggle of the Israelites to avoid error and sin is continuous and difficult, but possible and partially successful, according to Biblical teaching.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_217"
    }
  }, [_vm._v("The Bible is more sanguine about the possibility of Israel's faith overcoming the limits of its culture than Plato is about widespread emergence from the cave. The Greek philosopher taught that every culture is a cave, from which only the few could emerge into the light. John Paul II seems to be telling all people that they may live in a more or less dark cave, from which there is a possibility of emerging with the help of philosophical inquiry and religious faith. He knows that even the Christian faith and theology can be affected by the erroneous opinions and practices of the cave. That is why he exhorts Christians to respect philosophical inquiry, even to study the erroneous opinions of philosophers as a path to light.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_218"
    }
  }, [_vm._v("In the New Testament, “all peoples are invited to join in the process of self-transcendence of their own particularity, the process which first began in Israel.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn122_ch01",
      "id": "ch01_fn122"
    }
  }, [_vm._v("122")])]), _vm._v(" In other words, the New Testament teaches that all can overcome the love of their own and be liberated for communion with God and one another. Cardinal Ratzinger puts it this way: “Faith in Jesus Christ is of its nature a continual opening of the self: it is God breaking into the world of human beings and the response of human beings breaking out toward God, who at the same time leads them to one another.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn123_ch01",
      "id": "ch01_fn123"
    }
  }, [_vm._v("123")])]), _vm._v(" With the advent of Christianity no one is destined to remain in the cave because of inferior intellectual abilities. Christianity, in principle, frees Christians from the pervasive influence of the regime. In other words, people are not simply the product of the culture in which they live.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_219"
    }
  }, [_vm._v("This transcending of the particular also took place in the Greek world prior to the coming of Jesus Christ. This is what made possible the fruitful encounter between Greek philosophy and the fathers of the Church.\n"), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }), _vm._v("\n“The Fathers…did not simply mix an autonomous Greek culture into the Gospel,” writes Cardinal Ratzinger. “They were able to take up the dialogue with Greek philosophy and use it as an instrument for the Gospel, because in the Greek world a form of auto-criticism of their own culture…was already underway.” In other words, Greek philosophers were able to rise above limitations in their own culture and arrive at knowledge that is true for all time. As a result, when the Church brought the Christian faith to Asia, Africa, and America, she “introduced these people not to Greek culture as such, but rather to its capacity for self-transcendence which was the true connecting point for interpreting the Christian message.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn124_ch01",
      "id": "ch01_fn124"
    }
  }, [_vm._v("124")])]), _vm._v(" So, it is not the Hellenization of the faith that took place in the early Church, but an encounter between a faith and a philosophy, both of which transcended the cultures in which they emerged. That encounter, one of the great themes of Ernest Fortin's writing, became a guide and an exhortation to overcome love of one's own, particularity, the cave of one's culture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_220"
    }
  }, [_vm._v("Pope John Paul II believes that the Church's encounter with Greek philosophy gave the Church a heritage that can never be forgotten. He says,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_221"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_222"
    }
  }, [_vm._v("In engaging great cultures for the first time, the Church cannot abandon what she has gained from her inculturation in the world of Greco-Latin learning. To reject this heritage would be to deny the providential plan of God, who guides his Church down the path of time and history. This criterion is valid for the Church in every age."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn125_ch01",
      "id": "ch01_fn125"
    }
  }, [_vm._v("125")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_223"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_224"
    }
  }, [_vm._v("For example, the concepts of person and nature, as well as the Greek and Latin languages, can never be forsaken by the Church. So much of the Church's patrimony is in Greek or Latin, such as the New Testament, the original formulation of the Christological doctrines, and the writings of Augustine and Aquinas. While John Paul affirms the permanent validity of the Greco-Latin heritage in the Church, “this hardly means that other approaches are excluded.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn126_ch01",
      "id": "ch01_fn126"
    }
  }, [_vm._v("126")])]), _vm._v(" He is open to the possibility that people in other cultures will transcend their limits and provide humanity with eternal truths. To illustrate the drift of his thought, he says, “a great spiritual impulse leads the Indian mind to seek an experience which might attain absolute good, when the spirit is free from the shackles of time\n"), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _vm._v("\nand space.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn127_ch01",
      "id": "ch01_fn127"
    }
  }, [_vm._v("127")])]), _vm._v(" He also says that he expects the Church of the future to be enriched by its encounter with Eastern cultures. Like St. Paul, he urges Christians always to be open to whatever is true and good.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_225"
    }
  }, [_vm._v("Finally, John Paul II affirms that the Gospel truth can be “grasped across all boundaries of culture and time” and that it “can be expressed faithfully in many different languages.” Otherwise, Jesus's command to go and make disciples of all nations would make no sense. That the New Testament is written in a language different from that spoken by Jesus already shows, right from the beginning, that an accurate translation is possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_226"
    }
  }, [_vm._v("Because many people believe that a universal truth is an empty concept, a new notion of conscience has arisen. It is no longer generally regarded as a judgment of reason on the basis of an objective truth. “In what concerns morality and religion,” writes Cardinal Ratzinger in his German commentary on the encyclical, “the subject is the last authority. This is logical, if truth as such is inaccessible. So in recent times the concept of conscience is the canonization of relativism, the impossibility of common ethical and religious standards.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn128_ch01",
      "id": "ch01_fn128"
    }
  }, [_vm._v("128")])]), _vm._v(" Conscience has become a synonym for the absolute authority of the individual to create his own values."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn129_ch01",
      "id": "ch01_fn129"
    }
  }, [_vm._v("129")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_227"
    }
  }, [_vm._v("Cardinal Ratzinger makes clear that Christianity claims to speak the truth about God, man, and the world. “The fundamental claim of the Christian faith is expressed in the word of Christ from the gospel of John, ‘I am the way, the truth and the life.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn130_ch01",
      "id": "ch01_fn130"
    }
  }, [_vm._v("130")])]), _vm._v(" Today, the objection is raised that neither Christianity nor any other religion can rightfully claim to be the "), _c('i', [_vm._v("religio vera")]), _vm._v(", the true religion or the religion of truth. At the beginning of this century the Protestant theologian Ernst Troeltsch made this point by arguing that religion was the offshoot of a culture. He regarded Christianity as “a European affair” that cannot be exported to other lands. In looking at things this way, “the question of truth,” writes Ratzinger, “is in practice given up, the boundaries of cultures cannot be crossed.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn131_ch01",
      "id": "ch01_fn131"
    }
  }, [_vm._v("131")])]), _vm._v(" In an address given in French at the Sorbonne on November 27, 1999, Ratzinger described Troeltsch's position in slightly different terms. The cardinal said, “[Troeltsch] had arrived at the conviction that cultures are unsurpassable\n"), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }), _vm._v("\nand that religion is linked to cultures. Christianity is then only the side of God's face turned toward Europe.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn132_ch01",
      "id": "ch01_fn132"
    }
  }, [_vm._v("132")])]), _vm._v(" If this is so, what is to prevent changes in European culture that render Christianity unsuitable for Europeans, at least in their minds? Consequently, Ratzinger logically raises this question: “Is it perhaps necessary even to take one step more than Troeltsch, who still considered Christianity as the religion adapted to Europe, taking into account that Europe itself doubts that it is now suitable?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn133_ch01",
      "id": "ch01_fn133"
    }
  }, [_vm._v("133")])]), _vm._v(" In other words, on the basis of Troeltsch's reasoning, which is a historicist approach, there really is no compelling argument that Christianity can claim a permanent validity as the religion of Europe. If the culture changes and becomes, for example, relativist, then religion may and will follow suit, because “religion is linked to cultures.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_228"
    }
  }, [_vm._v("In trying “to rehabilitate the question of truth in a world marked by relativism,” the encyclical not only had to discuss the universal truth claims of faith and philosophy, but, according to Ratzinger, also had to ask “whether there can at all be a communion of cultures in one truth.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn134_ch01",
      "id": "ch01_fn134"
    }
  }, [_vm._v("134")])]), _vm._v(" In other words, is there a truth to which all cultures can look for guidance in recognizing erroneous opinions and bad morals? As we saw, the Old Testament teaches that the people of Israel had to overcome the limits of their own culture in order to have faith. They took their bearings by a transcendent truth. The New Testament invites everyone to overcome “love of their own,” to use the idiom of Plato. The implicit premise of the Bible is that every person can transcend the limits of his own culture by rising to the contemplation of truth on the wings of faith and/or reason. It is also the teaching of much philosophy that some measure of truth can be apprehended despite the limits of the culture in which one lives. So in John Paul II's mind, there is no doubt that there can be a communion of cultures in one truth, but not without great effort and a persevering love of truth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_229"
    }
  }, [_vm._v("If it is possible to arrive at truths that transcend culture, then it is certainly not impossible for the Church to put forth both negative and positive precepts as universally binding. The command to love God and neighbor is always valid, but may be carried out in various ways, because circumstances may change. Universally negative commandments are easier to state because there are certain kinds of actions that are always incompatible\n"), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }), _vm._v("\nwith human dignity, such as murder, adultery, fornication, homosexual activity, stealing, bearing false witness. Everyone in principle can come to see this, because the Ten Commandments forbidding these actions are part of the natural law.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead",
    attrs: {
      "id": "p_230"
    }
  }, [_vm._v("Conclusion")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_231"
    }
  }, [_vm._v("I have tried to show that the dignity of the human person must be understood both as a permanent endowment and an ongoing achievement. Because of the constant temptation to act beneath our dignity, we must strive and strain to avoid sin and practice virtue. The family, educational institutions, the Church, mediating institutions, and the state help people in various ways to live in accordance with their dignity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_232"
    }
  }, [_vm._v("Because of their great dignity, human beings have both duties and rights. To act in accordance with their dignity, they must practice the virtues required by the natural law. In obeying the natural law, people will necessarily respect the rights of their fellow human beings. Not to respect the genuine rights of others is to act beneath one's dignity. Hence, Mary Ann Glendon declared,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_233"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "p_234"
    }
  }, [_vm._v("From a Christian point of view,…[it] may be that human rights are grounded in the obligation of everyone to perfect one's own dignity, which in turn obliges one to respect the “given” spark of dignity of others whatever they may have done with it. In other words, it may be our own quest for dignity (individually and as a society) that requires us to refrain from inflicting cruel punishments on criminals, or from terminating the lives of the unborn and others whose faculties are underdeveloped or dormant."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn135_ch01",
      "id": "ch01_fn135"
    }
  }, [_vm._v("135")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex",
    attrs: {
      "id": "p_235"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_236"
    }
  }, [_vm._v("For the sake of safeguarding human rights, human dignity must not be understood to require only the protection of rights. Only when people are intent on perfecting their own dignity will they both attain their end in life and necessarily respect the rights of others. (Of course, people may respect the rights of their neighbors out of self-interest or fear, but such motives are inherently unreliable.) So, the best way of advancing the cause of rights is to promote a correct understanding of human dignity. People must first think about what they owe to others, rather that what claims they can make on them by asserting their rights.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_237"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn1",
      "id": "fn1_ch01"
    }
  }, [_vm._v("1")]), _vm._v(". C. S. Lewis, "), _c('i', [_vm._v("The Weight of Glory and Other Addresses")]), _vm._v(", rev. ed. (New York: Macmillan, 1980), 18–19; I found this reference in Peter Kreeft's book "), _c('i', [_vm._v("The Philosophy of Tolkien: The Worldview Behind")]), _vm._v(" The Lord of the Rings (San Francisco: Ignatius Press, 2005).")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_238"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn2",
      "id": "fn2_ch01"
    }
  }, [_vm._v("2")]), _vm._v(". Joseph Cardinal Höffner, "), _c('i', [_vm._v("Christian Social Teaching")]), _vm._v(", 2nd ed. (Bratislava: Lúc, 1997), 48.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_239"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn3",
      "id": "fn3_ch01"
    }
  }, [_vm._v("3")]), _vm._v(". Pope Pius XI, "), _c('i', [_vm._v("Divini redemptoris")]), _vm._v(", no. 29, quoted from Höffner, "), _c('i', [_vm._v("Christian Social Teaching")]), _vm._v(", 48.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_240"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn4",
      "id": "fn4_ch01"
    }
  }, [_vm._v("4")]), _vm._v(". Quoted from Frances X. Hogan and Marianne Rea-Luthin, “Exporting Death or Offering Compassion: Vignettes of the American Experience with Physician-assisted Suicide,” in "), _c('i', [_vm._v("The Dignity of the Dying Person: Proceedings of the Fifth Assembly of the Pontifical Academy for Life")]), _vm._v(", edited by Juan Correa and Elio Sgreccia (Vatican City: Librereia Editrice Vaticana, 2000), 378.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_241"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn5",
      "id": "fn5_ch01"
    }
  }, [_vm._v("5")]), _vm._v(". Pope John Paul II, "), _c('i', [_vm._v("Evangelium vitae (The Gospel of Life)")]), _vm._v(", no. 19.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_242"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn6",
      "id": "fn6_ch01"
    }
  }, [_vm._v("6")]), _vm._v(". Pope John Paul II, "), _c('i', [_vm._v("Christifideles laici (On the Vocation and Mission of the Lay Faithful in the Church and the Modern World)")]), _vm._v(", no. 37.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_243"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn7",
      "id": "fn7_ch01"
    }
  }, [_vm._v("7")]), _vm._v(". Vatican Council II, "), _c('i', [_vm._v("Gaudium et spes (Pastoral Constitution on the Church in the Modern World)")]), _vm._v(", no. 19, “Dignitatis humanae eximia ratio in vocatione hominis ad communionem cum Deo consistit”; for all Vatican II documents see Walter M. Abbott, ed., "), _c('i', [_vm._v("The Documents of Vatican II")]), _vm._v(" (New York: Guild Press, America Press, and Association Press, 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_244"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn8",
      "id": "fn8_ch01"
    }
  }, [_vm._v("8")]), _vm._v(". Ibid., no. 21.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_245"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn9",
      "id": "fn9_ch01"
    }
  }, [_vm._v("9")]), _vm._v(". Pope John Paul II, "), _c('i', [_vm._v("Veritatis splendor (Splendor of Truth)")]), _vm._v(", no. 34, quoting "), _c('i', [_vm._v("Gaudium et spes")]), _vm._v(", no. 17.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_246"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn10",
      "id": "fn10_ch01"
    }
  }, [_vm._v("10")]), _vm._v(". "), _c('i', [_vm._v("Gaudium et spes")]), _vm._v(", no. 17.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_247"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn11",
      "id": "fn11_ch01"
    }
  }, [_vm._v("11")]), _vm._v(". Ibid., no. 16.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_248"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn12",
      "id": "fn12_ch01"
    }
  }, [_vm._v("12")]), _vm._v(". Pope Leo XIII, "), _c('i', [_vm._v("Rerum novarum")]), _vm._v(", no. 37.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_249"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn13",
      "id": "fn13_ch01"
    }
  }, [_vm._v("13")]), _vm._v(". "), _c('i', [_vm._v("Catechism of the Catholic Church")]), _vm._v(" (Vatican City: Libreria Editrice Vaticana, 1994), no. 1691.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_250"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn14",
      "id": "fn14_ch01"
    }
  }, [_vm._v("14")]), _vm._v(". "), _c('i', [_vm._v("Veritatis splendor")]), _vm._v(", no. 34.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_251"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn15",
      "id": "fn15_ch01"
    }
  }, [_vm._v("15")]), _vm._v(". Pope John Paul II, "), _c('i', [_vm._v("Dominum et vivificantem (On the Holy Spirit in the Life of the Church and the World)")]), _vm._v(", no. 60.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_252"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn16",
      "id": "fn16_ch01"
    }
  }, [_vm._v("16")]), _vm._v(". Congregation for Catholic Education, "), _c('i', [_vm._v("Guidelines for the Study and Teaching of the Church's Social Doctrine in the Formation of Priests")]), _vm._v(" (Rome: Congregation for Catholic Education, 1988); reprinted in "), _c('i', [_vm._v("Origins")]), _vm._v(", vol. 19, no. 1 (1988): 182, 174.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_253"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn17",
      "id": "fn17_ch01"
    }
  }, [_vm._v("17")]), _vm._v(". Pontifical Council for Justice and Peace, "), _c('i', [_vm._v("Compendium of the Social Doctrine of the Church")]), _vm._v(" (Vatican City: Libreria Editrice Vaticana, 2004), no. 51, quoting Vatican Council II, "), _c('i', [_vm._v("Gaudium et spes")]), _vm._v(", no. 40.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_254"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn18",
      "id": "fn18_ch01"
    }
  }, [_vm._v("18")]), _vm._v(". "), _c('i', [_vm._v("Compendium of the Social Doctrine of the Church")]), _vm._v(", no. 116.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_255"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn19",
      "id": "fn19_ch01"
    }
  }, [_vm._v("19")]), _vm._v(". Ibid., no. 119.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_256"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn20",
      "id": "fn20_ch01"
    }
  }, [_vm._v("20")]), _vm._v(". Pope John Paul II, "), _c('i', [_vm._v("Centesimus annus (On The Hundredth Anniversary of Rerum Novarum)")]), _vm._v(" no. 11, quoting "), _c('i', [_vm._v("Gaudium et Spes")]), _vm._v(", no. 24.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_257"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn21",
      "id": "fn21_ch01"
    }
  }, [_vm._v("21")]), _vm._v(". U.S. Catholic Bishops, "), _c('i', [_vm._v("Sharing Catholic Social Teaching: Challenges and Directions")]), _vm._v(" (Washington, D.C.: United States Conference of Catholic Bishops, 1998), 4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_258"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn22",
      "id": "fn22_ch01"
    }
  }, [_vm._v("22")]), _vm._v(". U.S. Catholic Bishops, "), _c('i', [_vm._v("A Century of Social Teaching: A Common Heritage, A Continuing Challenge")]), _vm._v(" (Washington, D.C.: United States Conference of Catholic Bishops, 1990), 4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_259"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn23",
      "id": "fn23_ch01"
    }
  }, [_vm._v("23")]), _vm._v(". The argument in this chapter is not about the achievement of dignity with the "), _c('i', [_vm._v("indispensable")]), _vm._v(" help of divine grace, but about making known the importance of achieving holiness by living daily in accordance with one's dignity. This important aspect of dignity is too often omitted in presentations of CSD.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_260"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn24",
      "id": "fn24_ch01"
    }
  }, [_vm._v("24")]), _vm._v(". Pope John Paul II, "), _c('i', [_vm._v("Centesimus annus")]), _vm._v(", no. 65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_261"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn25",
      "id": "fn25_ch01"
    }
  }, [_vm._v("25")]), _vm._v(". "), _c('i', [_vm._v("Gaudium et spes")]), _vm._v(", no. 91: “ut, suam integram vocationem clarius percipientes, mundum praecellenti dignitati hominis conforment.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_262"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn26",
      "id": "fn26_ch01"
    }
  }, [_vm._v("26")]), _vm._v(". "), _c('i', [_vm._v("Gaudium et spes")]), _vm._v(", no. 9, modified translation and my emphasis.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_263"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn27",
      "id": "fn27_ch01"
    }
  }, [_vm._v("27")]), _vm._v(". "), _c('i', [_vm._v("Centesimus annus")]), _vm._v(", no. 55.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_264"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn28",
      "id": "fn28_ch01"
    }
  }, [_vm._v("28")]), _vm._v(". Pope John Paul II, “Homily at Camden Yards,” Baltimore, Md., Oct. 8, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_265"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn29",
      "id": "fn29_ch01"
    }
  }, [_vm._v("29")]), _vm._v(". Joseph Ratzinger, "), _c('i', [_vm._v("Introduction to Christianity")]), _vm._v(", tr. J. Foster (New York: Crossroad, 1988), 202. (This book is now published by Ignatius Press.)")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_265a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn30",
      "id": "fn30_ch01"
    }
  }, [_vm._v("30")]), _vm._v(". George A. Kelly, "), _c('i', [_vm._v("Inside My Father's House")]), _vm._v(" (New York: Doubleday, 1989), 18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_266"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn31",
      "id": "fn31_ch01"
    }
  }, [_vm._v("31")]), _vm._v(". Agatha Christie, “Wasps' Nest,” in "), _c('i', [_vm._v("Hercule Poirot's Casebook")]), _vm._v(" (New York: Dodd, Mead, 1984), 814.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_267"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn32",
      "id": "fn32_ch01"
    }
  }, [_vm._v("32")]), _vm._v(". Ibid., 818, my emphasis.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_268"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn33",
      "id": "fn33_ch01"
    }
  }, [_vm._v("33")]), _vm._v(". Ernest L. Fortin, "), _c('i', [_vm._v("The Birth of Philosophic Christianity: Studies in Early Christian and Medieval Thought")]), _vm._v(", vol. 1 of "), _c('i', [_vm._v("Collected Essays")]), _vm._v(", ed. J. Brian Benestad (Lanham, Md.: Rowman and Littlefield, 1996), 322.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_269"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn34",
      "id": "fn34_ch01"
    }
  }, [_vm._v("34")]), _vm._v(". For my critical reflections on the compatibility of Kass's thought with Catholic teaching, see J. Brian Benestad, “Review Essay on Leon Kass's "), _c('i', [_vm._v("Life, Liberty and the Defense of Dignity: The Challenge for Bioethics")]), _vm._v(" and "), _c('i', [_vm._v("Toward a More Natural Science: Biology and Human Affairs")]), _vm._v(",” "), _c('i', [_vm._v("National Catholic Bioethics Quarterly")]), _vm._v(" 5, no. 3 (Autumn 2005): 631–45.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_270"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn35",
      "id": "fn35_ch01"
    }
  }, [_vm._v("35")]), _vm._v(". Leon Kass, "), _c('i', [_vm._v("Life, Liberty and the Defense of Dignity: The Challenge for Bioethics")]), _vm._v(" (San Francisco: Encounter Books, 2002), 16.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_271"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn36",
      "id": "fn36_ch01"
    }
  }, [_vm._v("36")]), _vm._v(". Ibid., 17.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_272"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn37",
      "id": "fn37_ch01"
    }
  }, [_vm._v("37")]), _vm._v(". Ibid., 246.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_273"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn38",
      "id": "fn38_ch01"
    }
  }, [_vm._v("38")]), _vm._v(". Ibid., 247.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_274"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn39",
      "id": "fn39_ch01"
    }
  }, [_vm._v("39")]), _vm._v(". Ibid., 247.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_275"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn40",
      "id": "fn40_ch01"
    }
  }, [_vm._v("40")]), _vm._v(". Ibid., 242.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_276"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn41",
      "id": "fn41_ch01"
    }
  }, [_vm._v("41")]), _vm._v(". Ibid., 239.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_277"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn42",
      "id": "fn42_ch01"
    }
  }, [_vm._v("42")]), _vm._v(". Ibid., 239.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_278"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn43",
      "id": "fn43_ch01"
    }
  }, [_vm._v("43")]), _vm._v(". Ibid., 241.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_279"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn44",
      "id": "fn44_ch01"
    }
  }, [_vm._v("44")]), _vm._v(". Ibid., 248.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_280"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn45",
      "id": "fn45_ch01"
    }
  }, [_vm._v("45")]), _vm._v(". Ibid., 249.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_281"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn46",
      "id": "fn46_ch01"
    }
  }, [_vm._v("46")]), _vm._v(". Ibid., 253.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_282"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn47",
      "id": "fn47_ch01"
    }
  }, [_vm._v("47")]), _vm._v(". Avery Cardinal Dulles, “Human Rights: The United Nations and Papal Teaching,” in "), _c('i', [_vm._v("Church and Society: The Lawrence J. McGinley Lectures 1988–2007")]), _vm._v(" (New York: Fordham University Press, 2008), 278.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_283"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn48",
      "id": "fn48_ch01"
    }
  }, [_vm._v("48")]), _vm._v(". Pope John Paul II, “Address to the United Nations,” October 5, 1995, no. 2; cf. Vatican website under the travels of Pope John Paul II.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_284"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn49",
      "id": "fn49_ch01"
    }
  }, [_vm._v("49")]), _vm._v(". Cf. Mary Ann Glendon, "), _c('i', [_vm._v("A World Made New: Eleanor Roosevelt and the Universal Declaration of Human Rights")]), _vm._v(" (New York: Random House, 2001).")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_285"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn50",
      "id": "fn50_ch01"
    }
  }, [_vm._v("50")]), _vm._v(". Glendon, "), _c('i', [_vm._v("Rights Talk: The Impoverishment of Political Discourse")]), _vm._v(" (New York: Free Press, 1991), x.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_286"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn51",
      "id": "fn51_ch01"
    }
  }, [_vm._v("51")]), _vm._v(". Ibid., xi–xii.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_287"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn52",
      "id": "fn52_ch01"
    }
  }, [_vm._v("52")]), _vm._v(". Ibid., 3–4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_288"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn53",
      "id": "fn53_ch01"
    }
  }, [_vm._v("53")]), _vm._v(". Ibid., 10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_289"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn54",
      "id": "fn54_ch01"
    }
  }, [_vm._v("54")]), _vm._v(". Ibid., 13, quoting UN General Assembly, "), _c('i', [_vm._v("Universal Declaration of Human Rights")]), _vm._v(" (Lake Success: UN Department of Public Information, 1949), Art. 29; UN General Assembly, "), _c('i', [_vm._v("Universal Declaration of Human Rights")]), _vm._v(", Final Authorized Text (New York: UN Department of Public Information, 1952).")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_290"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn55",
      "id": "fn55_ch01"
    }
  }, [_vm._v("55")]), _vm._v(". "), _c('i', [_vm._v("Rights Talk")]), _vm._v(", 15.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_291"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn56",
      "id": "fn56_ch01"
    }
  }, [_vm._v("56")]), _vm._v(". Ibid., 20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_292"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn57",
      "id": "fn57_ch01"
    }
  }, [_vm._v("57")]), _vm._v(". Ibid., 26.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_293"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn58",
      "id": "fn58_ch01"
    }
  }, [_vm._v("58")]), _vm._v(". Ibid., 26.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_294"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn59",
      "id": "fn59_ch01"
    }
  }, [_vm._v("59")]), _vm._v(". Ibid., 40.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_295"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn60",
      "id": "fn60_ch01"
    }
  }, [_vm._v("60")]), _vm._v(". Ibid., 43.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_296"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn61",
      "id": "fn61_ch01"
    }
  }, [_vm._v("61")]), _vm._v(". Ibid., 43.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_297"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn62",
      "id": "fn62_ch01"
    }
  }, [_vm._v("62")]), _vm._v(". "), _c('i', [_vm._v("Rerum novarum")]), _vm._v(", no. 22.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_298"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn63",
      "id": "fn63_ch01"
    }
  }, [_vm._v("63")]), _vm._v(". Ibid., no. 22.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_299"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn64",
      "id": "fn64_ch01"
    }
  }, [_vm._v("64")]), _vm._v(". Ibid., no. 10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_300"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn65",
      "id": "fn65_ch01"
    }
  }, [_vm._v("65")]), _vm._v(". Ibid., no. 9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_301"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn66",
      "id": "fn66_ch01"
    }
  }, [_vm._v("66")]), _vm._v(". Ibid., no. 17.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_302"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn67",
      "id": "fn67_ch01"
    }
  }, [_vm._v("67")]), _vm._v(". Cf. ibid. no. 39.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_303"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn68",
      "id": "fn68_ch01"
    }
  }, [_vm._v("68")]), _vm._v(". Ibid., no. 18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_304"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn69",
      "id": "fn69_ch01"
    }
  }, [_vm._v("69")]), _vm._v(". Ibid., no. 9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_305"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn70",
      "id": "fn70_ch01"
    }
  }, [_vm._v("70")]), _vm._v(". Ibid., no. 20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_306"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn71",
      "id": "fn71_ch01"
    }
  }, [_vm._v("71")]), _vm._v(". Thomas Aquinas, "), _c('i', [_vm._v("Summa theologiae")]), _vm._v(", II-II, qu. 66, a. 2, reply to obj. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_307"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn72",
      "id": "fn72_ch01"
    }
  }, [_vm._v("72")]), _vm._v(". "), _c('i', [_vm._v("Rerum novarum")]), _vm._v(", no. 36.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_308"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn73",
      "id": "fn73_ch01"
    }
  }, [_vm._v("73")]), _vm._v(". Ibid., no. 36.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_309"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn74",
      "id": "fn74_ch01"
    }
  }, [_vm._v("74")]), _vm._v(". Ibid., no. 37.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_310"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn75",
      "id": "fn75_ch01"
    }
  }, [_vm._v("75")]), _vm._v(". Ibid., no. 41; Latin and Italian texts included to justify my modification of the English translation. The Italian "), _c('i', [_vm._v("costumi")]), _vm._v(" correctly translates "), _c('i', [_vm._v("institutorum")]), _vm._v(", whereas the English should be practices or customs, instead of institutions.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_311"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn76",
      "id": "fn76_ch01"
    }
  }, [_vm._v("76")]), _vm._v(". Ibid., no. 82.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_312"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn77",
      "id": "fn77_ch01"
    }
  }, [_vm._v("77")]), _vm._v(". Ernest L. Fortin, "), _c('i', [_vm._v("Human Rights, Virtue, and the Common Good: Untimely Meditations on Religion and Politics")]), _vm._v(", vol. 3 of "), _c('i', [_vm._v("Collected Essays")]), _vm._v(", ed. J. Brian Benestad (Lanham, Md.: Rowman and Littlefield, 1996), 20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_313"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn78",
      "id": "fn78_ch01"
    }
  }, [_vm._v("78")]), _vm._v(". Ibid., 23.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_314"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn79",
      "id": "fn79_ch01"
    }
  }, [_vm._v("79")]), _vm._v(". "), _c('i', [_vm._v("Gaudium et spes")]), _vm._v(", no. 41.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_315"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn80",
      "id": "fn80_ch01"
    }
  }, [_vm._v("80")]), _vm._v(". Pope John XXIII, "), _c('i', [_vm._v("Pacem in terris (Peace on Earth)")]), _vm._v(", no. 30.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_316"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn81",
      "id": "fn81_ch01"
    }
  }, [_vm._v("81")]), _vm._v(". Fortin, "), _c('i', [_vm._v("Human Rights, Virtue, and the Common Good")]), _vm._v(", 159.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_317"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn82",
      "id": "fn82_ch01"
    }
  }, [_vm._v("82")]), _vm._v(". Ibid., 163; King's exact words are as follows: “To put it in terms of St. Thomas Aquinas: An unjust law is a human law that is not rooted in eternal law and natural law.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_318"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn83",
      "id": "fn83_ch01"
    }
  }, [_vm._v("83")]), _vm._v(". Martin Luther King, Jr., “Letter From Birmingham City Jail,” in "), _c('i', [_vm._v("A Testament of Hope: The Essential Writings of Martin Luther King, Jr")]), _vm._v("., edited by James Melvin Washington (San Francisco: Harper and Row, 1986), 292–93.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_319"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn84",
      "id": "fn84_ch01"
    }
  }, [_vm._v("84")]), _vm._v(". "), _c('i', [_vm._v("Summa theologiae")]), _vm._v(", I, qu. 22, a. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_320"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn85",
      "id": "fn85_ch01"
    }
  }, [_vm._v("85")]), _vm._v(". Ibid., I-II, qu. 91, a. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_321"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn86",
      "id": "fn86_ch01"
    }
  }, [_vm._v("86")]), _vm._v(". Ibid., I-II, qu. 91, a. 2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_322"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn87",
      "id": "fn87_ch01"
    }
  }, [_vm._v("87")]), _vm._v(". Ibid., I-II, qu. 91, a. 2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_323"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn88",
      "id": "fn88_ch01"
    }
  }, [_vm._v("88")]), _vm._v(". Ibid., I-II, qu. 94, a. 2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_324"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn89",
      "id": "fn89_ch01"
    }
  }, [_vm._v("89")]), _vm._v(". Ibid., I-II, qu. 94, a. 4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_325"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn90",
      "id": "fn90_ch01"
    }
  }, [_vm._v("90")]), _vm._v(". Cf. Ibid., I-II, qu. 100, a. 2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_326"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn91",
      "id": "fn91_ch01"
    }
  }, [_vm._v("91")]), _vm._v(". Ibid., I-II, qu. 94, a. 3.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_327"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn92",
      "id": "fn92_ch01"
    }
  }, [_vm._v("92")]), _vm._v(". Ibid., I-II, qu. 94, a. 3.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_328"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn93",
      "id": "fn93_ch01"
    }
  }, [_vm._v("93")]), _vm._v(". Ibid., I-II, qu. 100, a. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_329"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn94",
      "id": "fn94_ch01"
    }
  }, [_vm._v("94")]), _vm._v(". Ibid., I, qu. 1, a. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_330"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn95",
      "id": "fn95_ch01"
    }
  }, [_vm._v("95")]), _vm._v(". Thomas Aquinas, "), _c('i', [_vm._v("Collationes in Decem Praeceptis")]), _vm._v(", I, line 27, édition critique avec introduction et notes par Jean-Pierre Torrell, in "), _c('i', [_vm._v("Revue des sciences philosophiques et théologiques")]), _vm._v(" 69 (1985): 5–40, 27–63; cited from Russell Hittinger, "), _c('i', [_vm._v("The First Grace: Rediscovering the Natural Law in a Post-Christian World")]), _vm._v(" (Wilmington, Del.: ISI, 2003), 11.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_331"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn96",
      "id": "fn96_ch01"
    }
  }, [_vm._v("96")]), _vm._v(". J. Budziszewski, "), _c('i', [_vm._v("What We Can't Not Know")]), _vm._v(" (Dallas: Spence, 2003), 25.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_332"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn97",
      "id": "fn97_ch01"
    }
  }, [_vm._v("97")]), _vm._v(". Ibid., 114–15.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_333"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn98",
      "id": "fn98_ch01"
    }
  }, [_vm._v("98")]), _vm._v(". Ibid., 80.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_334"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn99",
      "id": "fn99_ch01"
    }
  }, [_vm._v("99")]), _vm._v(". Ibid., 81.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_335"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn100",
      "id": "fn100_ch01"
    }
  }, [_vm._v("100")]), _vm._v(". Hittinger, "), _c('i', [_vm._v("The First Grace")]), _vm._v(", 97.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_336"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn101",
      "id": "fn101_ch01"
    }
  }, [_vm._v("101")]), _vm._v(". Ibid., 25.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_337"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn102",
      "id": "fn102_ch01"
    }
  }, [_vm._v("102")]), _vm._v(". "), _c('i', [_vm._v("Veritatis splendor")]), _vm._v(", no. 41.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_338"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn103",
      "id": "fn103_ch01"
    }
  }, [_vm._v("103")]), _vm._v(". Ibid., no. 32.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_339"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn104",
      "id": "fn104_ch01"
    }
  }, [_vm._v("104")]), _vm._v(". Ibid., no. 32.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_340"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn105",
      "id": "fn105_ch01"
    }
  }, [_vm._v("105")]), _vm._v(". Ibid., no. 40, citing Thomas Aquinas, "), _c('i', [_vm._v("In Duo Praecepta Caritatis et in Decem Legis Praecepta. Prologus, Opuscula Theologica")]), _vm._v(", II, no. 1129, edited by Raymundi A. Vercudo and Raymundi M. Spiazzi (Torino: Marietti, 1954), 245.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_341"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn106",
      "id": "fn106_ch01"
    }
  }, [_vm._v("106")]), _vm._v(". Ibid., no. 40.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_342"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn107",
      "id": "fn107_ch01"
    }
  }, [_vm._v("107")]), _vm._v(". Ibid., no. 43.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_343"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn108",
      "id": "fn108_ch01"
    }
  }, [_vm._v("108")]), _vm._v(". Ibid., quoting "), _c('i', [_vm._v("Summa theologiae")]), _vm._v(", I-II, qu. 91, a. 2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_344"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn109",
      "id": "fn109_ch01"
    }
  }, [_vm._v("109")]), _vm._v(". Ibid., quoting "), _c('i', [_vm._v("Dignitatis humanae (Declaration on Religious Freedom)")]), _vm._v(", 3; see Abbott, ed., "), _c('i', [_vm._v("The Documents of Vatican II")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_345"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn110",
      "id": "fn110_ch01"
    }
  }, [_vm._v("110")]), _vm._v(". Ibid., no. 48.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_346"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn111",
      "id": "fn111_ch01"
    }
  }, [_vm._v("111")]), _vm._v(". Hittinger, "), _c('i', [_vm._v("The First Grace")]), _vm._v(", 23, quoting Joseph Fuchs, "), _c('i', [_vm._v("Moral Demands and Personal Obligations")]), _vm._v(", trans. Brian McNeil (Washington, D.C.: Georgetown University Press, 1995), 55.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_347"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn112",
      "id": "fn112_ch01"
    }
  }, [_vm._v("112")]), _vm._v(". Pope John Paul II, "), _c('i', [_vm._v("Fides et ratio")]), _vm._v(", no. 87.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_348"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn113",
      "id": "fn113_ch01"
    }
  }, [_vm._v("113")]), _vm._v(". Ibid., no. 56.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_349"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn114",
      "id": "fn114_ch01"
    }
  }, [_vm._v("114")]), _vm._v(". C. S. Lewis, "), _c('i', [_vm._v("The Screwtape Letters")]), _vm._v(" (New York: Macmillan, 1961), 139–40, partially quoted in Joseph Cardinal Ratzinger, “Culture and Truth: Reflections on the Encyclical,” "), _c('i', [_vm._v("Origins")]), _vm._v(" 28, no. 36 (1999): 627.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_350"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn115",
      "id": "fn115_ch01"
    }
  }, [_vm._v("115")]), _vm._v(". Ratzinger, “Culture and Truth: Reflections on the Encyclical,” 627.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_351"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn116",
      "id": "fn116_ch01"
    }
  }, [_vm._v("116")]), _vm._v(". "), _c('i', [_vm._v("Fides et ratio")]), _vm._v(", no. 70.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_352"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn117",
      "id": "fn117_ch01"
    }
  }, [_vm._v("117")]), _vm._v(". Ibid., no. 71.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_353"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn118",
      "id": "fn118_ch01"
    }
  }, [_vm._v("118")]), _vm._v(". Ibid., no. 71.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_354"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn119",
      "id": "fn119_ch01"
    }
  }, [_vm._v("119")]), _vm._v(". Ibid., no. 72.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_355"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn120",
      "id": "fn120_ch01"
    }
  }, [_vm._v("120")]), _vm._v(". Ibid., no. 72.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_356"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn121",
      "id": "fn121_ch01"
    }
  }, [_vm._v("121")]), _vm._v(". Ratzinger, “Culture and Truth: Reflections on the Encyclical,” 629.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_357"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn122",
      "id": "fn122_ch01"
    }
  }, [_vm._v("122")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_358"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn123",
      "id": "fn123_ch01"
    }
  }, [_vm._v("123")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_359"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn124",
      "id": "fn124_ch01"
    }
  }, [_vm._v("124")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_360"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn125",
      "id": "fn125_ch01"
    }
  }, [_vm._v("125")]), _vm._v(". "), _c('i', [_vm._v("Fides et ratio")]), _vm._v(", no. 72.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_361"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn126",
      "id": "fn126_ch01"
    }
  }, [_vm._v("126")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_362"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn127",
      "id": "fn127_ch01"
    }
  }, [_vm._v("127")]), _vm._v(". Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_363"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn128",
      "id": "fn128_ch01"
    }
  }, [_vm._v("128")]), _vm._v(". Ratzinger, “Glaube, Wahrheit und Kultur: Reflexionen im Anschluss an die Enzyklika "), _c('i', [_vm._v("Fides et Ratio")]), _vm._v(",” unpublished text made available to the public, 18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_364"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn129",
      "id": "fn129_ch01"
    }
  }, [_vm._v("129")]), _vm._v(". See "), _c('i', [_vm._v("Veritatis splendor")]), _vm._v(", nos. 54–64.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_365"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn130",
      "id": "fn130_ch01"
    }
  }, [_vm._v("130")]), _vm._v(". Ratzinger, “Glaube, Wahrheit und Kultur,” 2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_366"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn131",
      "id": "fn131_ch01"
    }
  }, [_vm._v("131")]), _vm._v(". Ibid., 9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_367"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn132",
      "id": "fn132_ch01"
    }
  }, [_vm._v("132")]), _vm._v(". Ratzinger, “Vérité du Christianisme,” "), _c('i', [_vm._v("La documentation catholique")]), _vm._v(", no. 2217 (January 2, 2000): 29.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_368"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn133",
      "id": "fn133_ch01"
    }
  }, [_vm._v("133")]), _vm._v(". Ibid., 3–4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_369"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn134",
      "id": "fn134_ch01"
    }
  }, [_vm._v("134")]), _vm._v(". Ratzinger, “Glaube, Wahrheit und Kultur,” 9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnoteitem",
    attrs: {
      "id": "p_370"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ch01_fn135",
      "id": "fn135_ch01"
    }
  }, [_vm._v("135")]), _vm._v(". Mary Ann Glendon, "), _c('i', [_vm._v("Traditions in Turmoil")]), _vm._v(" (Ann Arbor, Mich.: Sapientia Press, 2006), 346.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b975c9b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 84
// module chunks = 0